const flashship = [
    {
        "variant_id": 12126,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12125,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12124,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12127,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12128,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12129,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12100,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11958,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11957,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11956,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11959,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11960,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11961,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11874,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11873,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11872,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11875,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11876,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11877,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11988,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11987,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11986,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11989,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11990,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11991,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12024,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12023,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12022,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12025,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12026,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12027,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12072,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12071,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12070,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12073,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12074,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12075,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11976,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11975,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11974,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11977,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11978,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11979,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11906,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11907,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 91943,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 91944,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 91945,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 91946,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 91947,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 91948,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11964,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11963,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11962,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11965,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11966,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11967,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12054,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12053,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12052,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12055,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12056,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12057,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 72997,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73011,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73025,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73039,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73053,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79471,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73009,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73023,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73037,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73051,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73065,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73079,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32894,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32895,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32896,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32897,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32898,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32899,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32902,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32903,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32904,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32905,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32906,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32907,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12144,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12143,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12142,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12145,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12146,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12147,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42164,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42165,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42166,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42167,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42168,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42169,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25397,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25428,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25459,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25490,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25521,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25552,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25396,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25427,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25458,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25489,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25520,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25551,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25400,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25431,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25462,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25493,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25524,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25555,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25394,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25425,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25456,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25487,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25518,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25549,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25395,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25426,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25457,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25488,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25519,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25550,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25386,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25417,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25448,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25479,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25510,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25541,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25404,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25435,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25466,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25497,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25528,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25406,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25387,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25418,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25449,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25480,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25511,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25542,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25391,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25422,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25453,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25484,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25515,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25546,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25625,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25624,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25623,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25626,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25627,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25628,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79457,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79458,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79459,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79460,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "Out Of Stock Soon"
    },
    {
        "variant_id": 79461,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79462,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51100,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "3.5x3.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51101,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "4.5x4.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79256,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79257,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79258,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79259,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79260,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79261,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42716,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42717,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42718,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42719,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42720,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42721,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12018,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12017,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12016,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12019,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12020,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12021,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73004,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73018,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73032,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73046,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73060,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73074,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121262,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121252,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121242,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121272,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121282,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121292,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121022,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121012,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121002,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 121032,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121042,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121052,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 119822,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "NATURAL_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NATURAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 119812,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "NATURAL_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NATURAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 119802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "NATURAL_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NATURAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 119832,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "NATURAL_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NATURAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 119842,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "NATURAL_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NATURAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 119852,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "NATURAL_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NATURAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 181482,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 181492,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 181502,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 181512,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 181522,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 181532,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12192,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12191,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12190,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12193,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12194,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12195,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24039,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24031,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24021,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24015,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24045,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23985,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23993,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24060,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23989,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 64268,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23947,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23983,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23955,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23965,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25583,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25582,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25581,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25586,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25577,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25629,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79262,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73081,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73093,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32908,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42170,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33423,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73088,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32900,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24171,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24164,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24153,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24147,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24178,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24118,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24126,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24194,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24122,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24138,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 64281,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24081,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21894,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24088,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24099,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24136,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25614,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25613,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25612,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25617,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25608,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25630,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79657,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73095,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73107,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32909,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42171,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33424,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73102,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32901,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 240392,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 240312,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 181542,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 239912,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "NATURAL_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NATURAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 241712,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "5XL",
        "color": "BLACK_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 241642,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "5XL",
        "color": "WHITE_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/WHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121263,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121023,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 790463,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 789913,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121253,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121013,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 790473,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 789923,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121243,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121003,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 790483,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 789933,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121273,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121033,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 790493,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 789943,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121283,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121043,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 790503,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 789953,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121293,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 121053,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 791553,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 791423,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 240393,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 240313,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 241543,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 241583,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 87900,
        "product_type": "TOTEBAG",
        "brand": "OAD113",
        "style": "OAD113",
        "size": "F",
        "color": "BLACK",
        "color_hex": "#000000",
        "product_image": "https://flashship.net/productImage/DetailProduct/TOTEBAG/OAD113/BLACK.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 87901,
        "product_type": "TOTEBAG",
        "brand": "OAD113",
        "style": "OAD113",
        "size": "F",
        "color": "NATURAL",
        "color_hex": "#DFD1A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/TOTEBAG/OAD113/NATURAL.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12012,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12011,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12010,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12013,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12014,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12015,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24134,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25389,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25420,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25451,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25482,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25513,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25544,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25575,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25606,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76974,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76980,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76986,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76992,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76998,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "2XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 84118,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "3XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76973,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76979,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/WHITE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 76985,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/WHITE_GD.jpeg",
        "stock": "Out Of Stock Soon"
    },
    {
        "variant_id": 76991,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76997,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "2XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 84128,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "3XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76969,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76975,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76981,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76987,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76993,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "2XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 84168,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "3XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/NAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 76972,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76978,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76984,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76990,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 76996,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "2XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 84138,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "3XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25388,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25419,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25450,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25481,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25512,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25543,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25574,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25605,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25381,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25412,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25443,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25474,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25505,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25536,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25567,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25598,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 181552,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "5XL",
        "color": "DARKGREYHEATHER_BC",
        "color_hex": "#4C5451",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKGREYHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 430005,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "S",
        "color": "MINERALBLACK_CT",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALBLACK_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 430015,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "M",
        "color": "MINERALBLACK_CT",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALBLACK_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 430025,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "L",
        "color": "MINERALBLACK_CT",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALBLACK_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 430035,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "XL",
        "color": "MINERALBLACK_CT",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALBLACK_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 430045,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "2XL",
        "color": "MINERALBLACK_CT",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALBLACK_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 430055,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "3XL",
        "color": "MINERALBLACK_CT",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALBLACK_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 431005,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "S",
        "color": "MINERALGRAY_CT",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALGRAY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 431015,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "M",
        "color": "MINERALGRAY_CT",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALGRAY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 431025,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "L",
        "color": "MINERALGRAY_CT",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALGRAY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 431035,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "XL",
        "color": "MINERALGRAY_CT",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALGRAY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 431045,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "2XL",
        "color": "MINERALGRAY_CT",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALGRAY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 431055,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "3XL",
        "color": "MINERALGRAY_CT",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALGRAY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 436005,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "S",
        "color": "MINERALNAVY_CT",
        "color_hex": "#012943",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALNAVY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 436015,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "M",
        "color": "MINERALNAVY_CT",
        "color_hex": "#012943",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALNAVY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 436025,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "L",
        "color": "MINERALNAVY_CT",
        "color_hex": "#012943",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALNAVY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 436035,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "XL",
        "color": "MINERALNAVY_CT",
        "color_hex": "#012943",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALNAVY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 436045,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "2XL",
        "color": "MINERALNAVY_CT",
        "color_hex": "#012943",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALNAVY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 436055,
        "product_type": "SHIRT",
        "brand": "COLORTONE",
        "style": "CT1300",
        "size": "3XL",
        "color": "MINERALNAVY_CT",
        "color_hex": "#012943",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/CT1300/MINERALNAVY_CT.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172513,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "ESPRESSO_CC",
        "color_hex": "#553C36",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ESPRESSO_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172213,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175613,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174313,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BAY_CC",
        "color_hex": "#94A596",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172523,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "ESPRESSO_CC",
        "color_hex": "#553C36",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ESPRESSO_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172223,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175623,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174323,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BAY_CC",
        "color_hex": "#94A596",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172533,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "ESPRESSO_CC",
        "color_hex": "#553C36",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ESPRESSO_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172233,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175633,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174333,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BAY_CC",
        "color_hex": "#94A596",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172543,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "ESPRESSO_CC",
        "color_hex": "#553C36",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ESPRESSO_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172243,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175643,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174343,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BAY_CC",
        "color_hex": "#94A596",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172553,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "ESPRESSO_CC",
        "color_hex": "#553C36",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ESPRESSO_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172253,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175653,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174353,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BAY_CC",
        "color_hex": "#94A596",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172563,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "ESPRESSO_CC",
        "color_hex": "#553C36",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ESPRESSO_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172263,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175663,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174363,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BAY_CC",
        "color_hex": "#94A596",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172573,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "ESPRESSO_CC",
        "color_hex": "#553C36",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ESPRESSO_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 172273,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175673,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174373,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BAY_CC",
        "color_hex": "#94A596",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15361,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15331,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15362,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15332,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15363,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15333,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15364,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15334,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15365,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15335,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173013,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "MOSS_CC",
        "color_hex": "#22372B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MOSS_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171913,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175713,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173023,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "MOSS_CC",
        "color_hex": "#22372B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MOSS_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171923,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175723,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173033,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "MOSS_CC",
        "color_hex": "#22372B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MOSS_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171933,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175733,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173043,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "MOSS_CC",
        "color_hex": "#22372B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MOSS_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171943,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175743,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173053,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "MOSS_CC",
        "color_hex": "#22372B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MOSS_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171953,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175753,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173063,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "MOSS_CC",
        "color_hex": "#22372B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MOSS_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171963,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175763,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173073,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "MOSS_CC",
        "color_hex": "#22372B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MOSS_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171973,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 175773,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171013,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173313,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BLOSSOM_CC",
        "color_hex": "#F8BED6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLOSSOM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 176013,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174513,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "GRAPHITE_CC",
        "color_hex": "#1D252D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171023,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173323,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BLOSSOM_CC",
        "color_hex": "#F8BED6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLOSSOM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 176023,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174523,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "GRAPHITE_CC",
        "color_hex": "#1D252D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171033,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173333,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BLOSSOM_CC",
        "color_hex": "#F8BED6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLOSSOM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 176033,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174533,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "GRAPHITE_CC",
        "color_hex": "#1D252D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171043,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173343,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BLOSSOM_CC",
        "color_hex": "#F8BED6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLOSSOM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 176043,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174543,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "GRAPHITE_CC",
        "color_hex": "#1D252D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171053,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173353,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BLOSSOM_CC",
        "color_hex": "#F8BED6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLOSSOM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 176053,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174553,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "GRAPHITE_CC",
        "color_hex": "#1D252D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171063,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173363,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BLOSSOM_CC",
        "color_hex": "#F8BED6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLOSSOM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 176063,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174563,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "GRAPHITE_CC",
        "color_hex": "#1D252D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 171073,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 173373,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BLOSSOM_CC",
        "color_hex": "#F8BED6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BLOSSOM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 176073,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 174573,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "GRAPHITE_CC",
        "color_hex": "#1D252D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPHITE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 60001,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10101,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "S",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 60002,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10102,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "M",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 60003,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10103,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "L",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 60004,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10104,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 60005,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "2XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10105,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "2XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 60006,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "3XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/RED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 10106,
        "product_type": "TANKTOP",
        "brand": "GILDAN",
        "style": "G2200",
        "size": "3XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/G2200/ROYAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 10201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10206,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10207,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ANTIQUEIRISHGREEN_GD",
        "color_hex": "#00843D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEIRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ANTIQUEIRISHGREEN_GD",
        "color_hex": "#00843D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEIRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ANTIQUEIRISHGREEN_GD",
        "color_hex": "#00843D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEIRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ANTIQUEIRISHGREEN_GD",
        "color_hex": "#00843D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEIRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ANTIQUEIRISHGREEN_GD",
        "color_hex": "#00843D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEIRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10306,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ANTIQUEIRISHGREEN_GD",
        "color_hex": "#00843D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEIRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ANTIQUEJADEDOME_GD",
        "color_hex": "#006269",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEJADEDOME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ANTIQUEJADEDOME_GD",
        "color_hex": "#006269",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEJADEDOME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ANTIQUEJADEDOME_GD",
        "color_hex": "#006269",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEJADEDOME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ANTIQUEJADEDOME_GD",
        "color_hex": "#006269",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEJADEDOME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ANTIQUEJADEDOME_GD",
        "color_hex": "#006269",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEJADEDOME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10406,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ANTIQUEJADEDOME_GD",
        "color_hex": "#006269",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEJADEDOME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10407,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "ANTIQUEJADEDOME_GD",
        "color_hex": "#006269",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEJADEDOME_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 10501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ANTIQUEORANGE_GD",
        "color_hex": "#B33D26",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ANTIQUEORANGE_GD",
        "color_hex": "#B33D26",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ANTIQUEORANGE_GD",
        "color_hex": "#B33D26",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ANTIQUEORANGE_GD",
        "color_hex": "#B33D26",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ANTIQUEORANGE_GD",
        "color_hex": "#B33D26",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10506,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ANTIQUEORANGE_GD",
        "color_hex": "#B33D26",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ANTIQUEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AQUATIC_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 10702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AQUATIC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AQUATIC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AQUATIC_GD.jpeg",
        "stock": "Out Of Stock Soon"
    },
    {
        "variant_id": 10705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AQUATIC_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 10706,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AQUATIC_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 10801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10806,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10807,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10808,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10901,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "BERRY_GD",
        "color_hex": "#7F2952",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BERRY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "BERRY_GD",
        "color_hex": "#7F2952",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BERRY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "BERRY_GD",
        "color_hex": "#7F2952",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BERRY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "BERRY_GD",
        "color_hex": "#7F2952",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BERRY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "BERRY_GD",
        "color_hex": "#7F2952",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BERRY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 10906,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "BERRY_GD",
        "color_hex": "#7F2952",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BERRY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "BROWNSAVANA_GD",
        "color_hex": "#7A6855",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BROWNSAVANA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "BROWNSAVANA_GD",
        "color_hex": "#7A6855",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BROWNSAVANA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "BROWNSAVANA_GD",
        "color_hex": "#7A6855",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BROWNSAVANA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "BROWNSAVANA_GD",
        "color_hex": "#7A6855",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BROWNSAVANA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "BROWNSAVANA_GD",
        "color_hex": "#7A6855",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BROWNSAVANA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11206,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "BROWNSAVANA_GD",
        "color_hex": "#7A6855",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/BROWNSAVANA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11306,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11307,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11308,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11406,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11407,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11408,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11506,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11806,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11807,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 11808,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12006,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12007,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12008,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12206,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12306,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12307,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12308,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ELECTRICGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 12402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "GARNET_GD",
        "color_hex": "#7D2935",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GARNET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "Out Of Stock Soon"
    },
    {
        "variant_id": 12505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12506,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12507,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12508,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "GRAVEL_GD",
        "color_hex": "#888B8D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GRAVEL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "GRAVEL_GD",
        "color_hex": "#888B8D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GRAVEL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "GRAVEL_GD",
        "color_hex": "#888B8D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/GRAVEL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "HEATHERMILITARYGREEN_GD",
        "color_hex": "#7E7F74",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERMILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "HEATHERMILITARYGREEN_GD",
        "color_hex": "#7E7F74",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERMILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "HEATHERMILITARYGREEN_GD",
        "color_hex": "#7E7F74",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERMILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "HEATHERMILITARYGREEN_GD",
        "color_hex": "#7E7F74",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERMILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "HEATHERMILITARYGREEN_GD",
        "color_hex": "#7E7F74",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERMILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12806,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "HEATHERMILITARYGREEN_GD",
        "color_hex": "#7E7F74",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERMILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12807,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "HEATHERMILITARYGREEN_GD",
        "color_hex": "#7E7F74",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERMILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 12904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13006,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13007,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13008,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "HEATHERRADIANTORCHID_GD",
        "color_hex": "#A15A95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HEATHERRADIANTORCHID_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 13301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13306,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13307,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13308,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/HELICONIA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 13401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "ICEGREY_GD",
        "color_hex": "#D7D2CB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ICEGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "ICEGREY_GD",
        "color_hex": "#D7D2CB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ICEGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "ICEGREY_GD",
        "color_hex": "#D7D2CB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ICEGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "ICEGREY_GD",
        "color_hex": "#D7D2CB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ICEGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13406,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "ICEGREY_GD",
        "color_hex": "#D7D2CB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ICEGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13407,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "ICEGREY_GD",
        "color_hex": "#D7D2CB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/ICEGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13601,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13606,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13607,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13608,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "KIWI_GD",
        "color_hex": "#89A84F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/KIWI_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 13702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "KIWI_GD",
        "color_hex": "#89A84F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/KIWI_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 13703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "KIWI_GD",
        "color_hex": "#89A84F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/KIWI_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "KIWI_GD",
        "color_hex": "#89A84F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/KIWI_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "KIWI_GD",
        "color_hex": "#89A84F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/KIWI_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13706,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "KIWI_GD",
        "color_hex": "#89A84F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/KIWI_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13707,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "KIWI_GD",
        "color_hex": "#89A84F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/KIWI_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "LILAC_GD",
        "color_hex": "#563D82",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LILAC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "LILAC_GD",
        "color_hex": "#563D82",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LILAC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "LILAC_GD",
        "color_hex": "#563D82",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LILAC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "LILAC_GD",
        "color_hex": "#563D82",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LILAC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "LILAC_GD",
        "color_hex": "#563D82",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LILAC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13806,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "LILAC_GD",
        "color_hex": "#563D82",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LILAC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13906,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13907,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 13908,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14106,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14107,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14108,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14206,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14207,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14208,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "NEONBLUE_GD",
        "color_hex": "#0C51A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NEONBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "NEONBLUE_GD",
        "color_hex": "#0C51A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NEONBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "NEONBLUE_GD",
        "color_hex": "#0C51A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NEONBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "NEONBLUE_GD",
        "color_hex": "#0C51A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NEONBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "NEONBLUE_GD",
        "color_hex": "#0C51A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NEONBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14306,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "NEONBLUE_GD",
        "color_hex": "#0C51A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/NEONBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14506,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14507,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/OFFWHITE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 14901,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14906,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14907,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 14908,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAFETYPINK_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15006,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15106,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15107,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15108,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15406,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15407,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15408,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SKY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "SUNSET_GD",
        "color_hex": "#DC6B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SUNSET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "SUNSET_GD",
        "color_hex": "#DC6B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SUNSET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "SUNSET_GD",
        "color_hex": "#DC6B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SUNSET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "SUNSET_GD",
        "color_hex": "#DC6B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SUNSET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "SUNSET_GD",
        "color_hex": "#DC6B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SUNSET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15506,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "SUNSET_GD",
        "color_hex": "#DC6B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/SUNSET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15601,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "TANGERINE_GD",
        "color_hex": "#FF8A3D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TANGERINE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "TANGERINE_GD",
        "color_hex": "#FF8A3D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TANGERINE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "TANGERINE_GD",
        "color_hex": "#FF8A3D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TANGERINE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "TANGERINE_GD",
        "color_hex": "#FF8A3D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TANGERINE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "TANGERINE_GD",
        "color_hex": "#FF8A3D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TANGERINE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15606,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "TANGERINE_GD",
        "color_hex": "#FF8A3D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TANGERINE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15706,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15707,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TENNESSEEORANGE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15806,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15807,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15901,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 15906,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 15908,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 16001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "TURFGREEN_GD",
        "color_hex": "#007A3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TURFGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "TURFGREEN_GD",
        "color_hex": "#007A3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TURFGREEN_GD.jpeg",
        "stock": "Out Of Stock Soon"
    },
    {
        "variant_id": 16003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "TURFGREEN_GD",
        "color_hex": "#007A3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TURFGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 16004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "TURFGREEN_GD",
        "color_hex": "#007A3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TURFGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "TURFGREEN_GD",
        "color_hex": "#007A3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TURFGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16006,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "TURFGREEN_GD",
        "color_hex": "#007A3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TURFGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "TWEED_GD",
        "color_hex": "#4B4F54",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TWEED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "TWEED_GD",
        "color_hex": "#4B4F54",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TWEED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "TWEED_GD",
        "color_hex": "#4B4F54",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TWEED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "TWEED_GD",
        "color_hex": "#4B4F54",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TWEED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "TWEED_GD",
        "color_hex": "#4B4F54",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TWEED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16106,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "TWEED_GD",
        "color_hex": "#4B4F54",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TWEED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16107,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "TWEED_GD",
        "color_hex": "#4B4F54",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/TWEED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16206,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16207,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16208,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "S",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "M",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "L",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "XL",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "2XL",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16306,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "3XL",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16307,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "4XL",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16308,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000",
        "size": "5XL",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16601,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16901,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 16905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CHARCOAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 17102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CHARCOAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 17103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/CHARCOAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 17201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "COBALT_GD",
        "color_hex": "#171C8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/COBALT_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17601,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 17805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "ELECTRICGREEN_GD",
        "color_hex": "#43B02A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ELECTRICGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "HEATHERRED_GD",
        "color_hex": "#BF0D3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "HEATHERRED_GD",
        "color_hex": "#BF0D3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "HEATHERRED_GD",
        "color_hex": "#BF0D3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "HEATHERRED_GD",
        "color_hex": "#BF0D3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "HEATHERRED_GD",
        "color_hex": "#BF0D3E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18601,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/INDIGOBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 18801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18901,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 18905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "LIME_GD",
        "color_hex": "#92BF55",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/LIME_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MAROON_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 19005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 19203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 19301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "NATURAL_GD",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NATURAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19901,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 19905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "SAFETYGREEN_GD",
        "color_hex": "#C6D219",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "SAFETYGREEN_GD",
        "color_hex": "#C6D219",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "SAFETYGREEN_GD",
        "color_hex": "#C6D219",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "SAFETYGREEN_GD",
        "color_hex": "#C6D219",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "SAFETYGREEN_GD",
        "color_hex": "#C6D219",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "SAND_GD",
        "color_hex": "#CABFAD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAND_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20601,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "SKY_GD",
        "color_hex": "#71C5E8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SKY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20801,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20802,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20803,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20804,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20805,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20901,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20902,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TENNESSEEORANGE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 20903,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20904,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 20905,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "TENNESSEEORANGE_GD",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TENNESSEEORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21001,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21002,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21003,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21004,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TORANGE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 21005,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "TORANGE_GD",
        "color_hex": "#B65A30",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21101,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21102,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21103,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21104,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21105,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/TROPICALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21201,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21202,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21203,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21204,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21205,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21301,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "S",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21302,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "M",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21303,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "L",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21304,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XL",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21305,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000B",
        "size": "XS",
        "color": "YELLOWHAZE_GD",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000B/YELLOWHAZE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21401,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "AQUA_BC",
        "color_hex": "#4298B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AQUA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21402,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "AQUA_BC",
        "color_hex": "#4298B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AQUA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21403,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "AQUA_BC",
        "color_hex": "#4298B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AQUA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21404,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "AQUA_BC",
        "color_hex": "#4298B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AQUA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21405,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "AQUA_BC",
        "color_hex": "#4298B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AQUA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21406,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "AQUA_BC",
        "color_hex": "#4298B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AQUA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21407,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "AQUA_BC",
        "color_hex": "#4298B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AQUA_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 21601,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "ASHGREY_BC",
        "color_hex": "#BDC4C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASHGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21602,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "ASHGREY_BC",
        "color_hex": "#BDC4C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASHGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21603,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "ASHGREY_BC",
        "color_hex": "#BDC4C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASHGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21604,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "ASHGREY_BC",
        "color_hex": "#BDC4C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASHGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21605,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "ASHGREY_BC",
        "color_hex": "#BDC4C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASHGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21606,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "ASHGREY_BC",
        "color_hex": "#BDC4C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASHGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21607,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "ASHGREY_BC",
        "color_hex": "#BDC4C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASHGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21701,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "ASPHALT_BC",
        "color_hex": "#6C6864",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASPHALT_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21702,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "ASPHALT_BC",
        "color_hex": "#6C6864",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASPHALT_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21703,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "ASPHALT_BC",
        "color_hex": "#6C6864",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASPHALT_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 21704,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "ASPHALT_BC",
        "color_hex": "#6C6864",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASPHALT_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 21705,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "ASPHALT_BC",
        "color_hex": "#6C6864",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASPHALT_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 21706,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "ASPHALT_BC",
        "color_hex": "#6C6864",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASPHALT_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21707,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "ASPHALT_BC",
        "color_hex": "#6C6864",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ASPHALT_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "ATLANTIC_BC",
        "color_hex": "#034146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ATLANTIC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "ATLANTIC_BC",
        "color_hex": "#034146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ATLANTIC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "ATLANTIC_BC",
        "color_hex": "#034146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ATLANTIC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "ATLANTIC_BC",
        "color_hex": "#034146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ATLANTIC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "ATLANTIC_BC",
        "color_hex": "#034146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ATLANTIC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "ATLANTIC_BC",
        "color_hex": "#034146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ATLANTIC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "ATLANTIC_BC",
        "color_hex": "#034146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ATLANTIC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21901,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "AUTUMN_BC",
        "color_hex": "#944A1F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AUTUMN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21902,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "AUTUMN_BC",
        "color_hex": "#944A1F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AUTUMN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21903,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "AUTUMN_BC",
        "color_hex": "#944A1F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AUTUMN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21904,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "AUTUMN_BC",
        "color_hex": "#944A1F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AUTUMN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21905,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "AUTUMN_BC",
        "color_hex": "#944A1F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AUTUMN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21906,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "AUTUMN_BC",
        "color_hex": "#944A1F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AUTUMN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 21907,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "AUTUMN_BC",
        "color_hex": "#944A1F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/AUTUMN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 22201,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "BLUESTORM_BC",
        "color_hex": "#636968",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLUESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22202,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "BLUESTORM_BC",
        "color_hex": "#636968",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLUESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22203,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "BLUESTORM_BC",
        "color_hex": "#636968",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLUESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22204,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "BLUESTORM_BC",
        "color_hex": "#636968",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLUESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22205,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "BLUESTORM_BC",
        "color_hex": "#636968",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLUESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22206,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "BLUESTORM_BC",
        "color_hex": "#636968",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLUESTORM_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 22207,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "BLUESTORM_BC",
        "color_hex": "#636968",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BLUESTORM_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 22301,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "BROWN_BC",
        "color_hex": "#423A31",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22302,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "BROWN_BC",
        "color_hex": "#423A31",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22303,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "BROWN_BC",
        "color_hex": "#423A31",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22304,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "BROWN_BC",
        "color_hex": "#423A31",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22305,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "BROWN_BC",
        "color_hex": "#423A31",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22306,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "BROWN_BC",
        "color_hex": "#423A31",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22307,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "BROWN_BC",
        "color_hex": "#423A31",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/BROWN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 22701,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "CAROLINABLUE_BC",
        "color_hex": "#88A7D2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CAROLINABLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22702,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "CAROLINABLUE_BC",
        "color_hex": "#88A7D2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CAROLINABLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22703,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "CAROLINABLUE_BC",
        "color_hex": "#88A7D2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CAROLINABLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22704,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "CAROLINABLUE_BC",
        "color_hex": "#88A7D2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CAROLINABLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22705,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "CAROLINABLUE_BC",
        "color_hex": "#88A7D2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CAROLINABLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22706,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "CAROLINABLUE_BC",
        "color_hex": "#88A7D2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CAROLINABLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22707,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "CAROLINABLUE_BC",
        "color_hex": "#88A7D2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CAROLINABLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "CHARITYPINK_BC",
        "color_hex": "#DE5795",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CHARITYPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "CHARITYPINK_BC",
        "color_hex": "#DE5795",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CHARITYPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "CHARITYPINK_BC",
        "color_hex": "#DE5795",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CHARITYPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "CHARITYPINK_BC",
        "color_hex": "#DE5795",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CHARITYPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "CHARITYPINK_BC",
        "color_hex": "#DE5795",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CHARITYPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "CHARITYPINK_BC",
        "color_hex": "#DE5795",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CHARITYPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 22807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "CHARITYPINK_BC",
        "color_hex": "#DE5795",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/CHARITYPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23601,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "DARKLAVENDER_BC",
        "color_hex": "#A194C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKLAVENDER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23602,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "DARKLAVENDER_BC",
        "color_hex": "#A194C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKLAVENDER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23603,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "DARKLAVENDER_BC",
        "color_hex": "#A194C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKLAVENDER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23604,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "DARKLAVENDER_BC",
        "color_hex": "#A194C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKLAVENDER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23605,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "DARKLAVENDER_BC",
        "color_hex": "#A194C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKLAVENDER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23606,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "DARKLAVENDER_BC",
        "color_hex": "#A194C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKLAVENDER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 23607,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "DARKLAVENDER_BC",
        "color_hex": "#A194C2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DARKLAVENDER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24103,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "DUSTYBLUE_BC",
        "color_hex": "#A5BCBB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DUSTYBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24104,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "DUSTYBLUE_BC",
        "color_hex": "#A5BCBB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/DUSTYBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24301,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "EVERGREEN_BC",
        "color_hex": "#115740",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/EVERGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24302,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "EVERGREEN_BC",
        "color_hex": "#115740",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/EVERGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24303,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "EVERGREEN_BC",
        "color_hex": "#115740",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/EVERGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24304,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "EVERGREEN_BC",
        "color_hex": "#115740",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/EVERGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24305,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "EVERGREEN_BC",
        "color_hex": "#115740",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/EVERGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24306,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "EVERGREEN_BC",
        "color_hex": "#115740",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/EVERGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24307,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "EVERGREEN_BC",
        "color_hex": "#115740",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/EVERGREEN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 24401,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "FORESTGREEN_BC",
        "color_hex": "#183029",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/FORESTGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24402,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "FORESTGREEN_BC",
        "color_hex": "#183029",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/FORESTGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24403,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "FORESTGREEN_BC",
        "color_hex": "#183029",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/FORESTGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24404,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "FORESTGREEN_BC",
        "color_hex": "#183029",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/FORESTGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24405,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "FORESTGREEN_BC",
        "color_hex": "#183029",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/FORESTGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24406,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "FORESTGREEN_BC",
        "color_hex": "#183029",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/FORESTGREEN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 24407,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "FORESTGREEN_BC",
        "color_hex": "#183029",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/FORESTGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "KELLY_BC",
        "color_hex": "#007A53",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/KELLY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "KELLY_BC",
        "color_hex": "#007A53",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/KELLY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "KELLY_BC",
        "color_hex": "#007A53",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/KELLY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "KELLY_BC",
        "color_hex": "#007A53",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/KELLY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "KELLY_BC",
        "color_hex": "#007A53",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/KELLY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "KELLY_BC",
        "color_hex": "#007A53",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/KELLY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "KELLY_BC",
        "color_hex": "#007A53",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/KELLY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24901,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "LAVENDERBLUE_BC",
        "color_hex": "#787F9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LAVENDERBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24902,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "LAVENDERBLUE_BC",
        "color_hex": "#787F9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LAVENDERBLUE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 24903,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "LAVENDERBLUE_BC",
        "color_hex": "#787F9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LAVENDERBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24904,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "LAVENDERBLUE_BC",
        "color_hex": "#787F9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LAVENDERBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24905,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "LAVENDERBLUE_BC",
        "color_hex": "#787F9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LAVENDERBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24906,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "LAVENDERBLUE_BC",
        "color_hex": "#787F9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LAVENDERBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 24907,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "LAVENDERBLUE_BC",
        "color_hex": "#787F9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LAVENDERBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25101,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "LEAF_BC",
        "color_hex": "#74956C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LEAF_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 25102,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "LEAF_BC",
        "color_hex": "#74956C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LEAF_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25103,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "LEAF_BC",
        "color_hex": "#74956C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LEAF_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25104,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "LEAF_BC",
        "color_hex": "#74956C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LEAF_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25105,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "LEAF_BC",
        "color_hex": "#74956C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LEAF_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25106,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "LEAF_BC",
        "color_hex": "#74956C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LEAF_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25107,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "LEAF_BC",
        "color_hex": "#74956C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LEAF_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 25201,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "LIGHTBLUE_BC",
        "color_hex": "#A6BBC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25202,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "LIGHTBLUE_BC",
        "color_hex": "#A6BBC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25203,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "LIGHTBLUE_BC",
        "color_hex": "#A6BBC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25204,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "LIGHTBLUE_BC",
        "color_hex": "#A6BBC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25205,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "LIGHTBLUE_BC",
        "color_hex": "#A6BBC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25206,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "LIGHTBLUE_BC",
        "color_hex": "#A6BBC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25207,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "LIGHTBLUE_BC",
        "color_hex": "#A6BBC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTBLUE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 25301,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "LIGHTVIOLET_BC",
        "color_hex": "#A49CA2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTVIOLET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25302,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "LIGHTVIOLET_BC",
        "color_hex": "#A49CA2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTVIOLET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25303,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "LIGHTVIOLET_BC",
        "color_hex": "#A49CA2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTVIOLET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25304,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "LIGHTVIOLET_BC",
        "color_hex": "#A49CA2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTVIOLET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25305,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "LIGHTVIOLET_BC",
        "color_hex": "#A49CA2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTVIOLET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25306,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "LIGHTVIOLET_BC",
        "color_hex": "#A49CA2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTVIOLET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25307,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "LIGHTVIOLET_BC",
        "color_hex": "#A49CA2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LIGHTVIOLET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25701,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "LILAC_BC",
        "color_hex": "#D1ACCE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LILAC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25702,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "LILAC_BC",
        "color_hex": "#D1ACCE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LILAC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25703,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "LILAC_BC",
        "color_hex": "#D1ACCE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LILAC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25704,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "LILAC_BC",
        "color_hex": "#D1ACCE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LILAC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25705,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "LILAC_BC",
        "color_hex": "#D1ACCE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LILAC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25706,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "LILAC_BC",
        "color_hex": "#D1ACCE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LILAC_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 25707,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "LILAC_BC",
        "color_hex": "#D1ACCE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/LILAC_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25901,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "MARINE_BC",
        "color_hex": "#007894",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MARINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25902,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "MARINE_BC",
        "color_hex": "#007894",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MARINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25903,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "MARINE_BC",
        "color_hex": "#007894",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MARINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25904,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "MARINE_BC",
        "color_hex": "#007894",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MARINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25905,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "MARINE_BC",
        "color_hex": "#007894",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MARINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25906,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "MARINE_BC",
        "color_hex": "#007894",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MARINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 25907,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "MARINE_BC",
        "color_hex": "#007894",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MARINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26001,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "MAROON_BC",
        "color_hex": "#672E45",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAROON_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26002,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "MAROON_BC",
        "color_hex": "#672E45",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAROON_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26003,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "MAROON_BC",
        "color_hex": "#672E45",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAROON_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26004,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "MAROON_BC",
        "color_hex": "#672E45",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAROON_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26005,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "MAROON_BC",
        "color_hex": "#672E45",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAROON_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26006,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "MAROON_BC",
        "color_hex": "#672E45",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAROON_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26007,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "MAROON_BC",
        "color_hex": "#672E45",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAROON_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 26101,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "MAUVE_BC",
        "color_hex": "#B46B6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAUVE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26102,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "MAUVE_BC",
        "color_hex": "#B46B6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAUVE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26103,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "MAUVE_BC",
        "color_hex": "#B46B6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAUVE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26104,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "MAUVE_BC",
        "color_hex": "#B46B6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAUVE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26105,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "MAUVE_BC",
        "color_hex": "#B46B6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAUVE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26106,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "MAUVE_BC",
        "color_hex": "#B46B6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAUVE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26107,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "MAUVE_BC",
        "color_hex": "#B46B6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MAUVE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 26401,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "MUSTARD_BC",
        "color_hex": "#C6973F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MUSTARD_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26402,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "MUSTARD_BC",
        "color_hex": "#C6973F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MUSTARD_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 26403,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "MUSTARD_BC",
        "color_hex": "#C6973F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MUSTARD_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 26404,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "MUSTARD_BC",
        "color_hex": "#C6973F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MUSTARD_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26405,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "MUSTARD_BC",
        "color_hex": "#C6973F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MUSTARD_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26406,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "MUSTARD_BC",
        "color_hex": "#C6973F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MUSTARD_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26407,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "MUSTARD_BC",
        "color_hex": "#C6973F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/MUSTARD_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26501,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26502,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26503,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26504,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26505,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26506,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26507,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26508,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "5XL",
        "color": "NAVY_BC",
        "color_hex": "#202A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/NAVY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 26801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "ORANGE_BC",
        "color_hex": "#FF6A39",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ORANGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "ORANGE_BC",
        "color_hex": "#FF6A39",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ORANGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "ORANGE_BC",
        "color_hex": "#FF6A39",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ORANGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "ORANGE_BC",
        "color_hex": "#FF6A39",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ORANGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "ORANGE_BC",
        "color_hex": "#FF6A39",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ORANGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "ORANGE_BC",
        "color_hex": "#FF6A39",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ORANGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 26807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "ORANGE_BC",
        "color_hex": "#FF6A39",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ORANGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27001,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "OXBLOODBLACK_BC",
        "color_hex": "#55394D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/OXBLOODBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27002,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "OXBLOODBLACK_BC",
        "color_hex": "#55394D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/OXBLOODBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27003,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "OXBLOODBLACK_BC",
        "color_hex": "#55394D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/OXBLOODBLACK_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 27004,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "OXBLOODBLACK_BC",
        "color_hex": "#55394D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/OXBLOODBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27005,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "OXBLOODBLACK_BC",
        "color_hex": "#55394D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/OXBLOODBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27006,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "OXBLOODBLACK_BC",
        "color_hex": "#55394D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/OXBLOODBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27007,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "OXBLOODBLACK_BC",
        "color_hex": "#55394D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/OXBLOODBLACK_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 27201,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "PEBBLEBROWN_BC",
        "color_hex": "#857874",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PEBBLEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27202,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "PEBBLEBROWN_BC",
        "color_hex": "#857874",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PEBBLEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27203,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "PEBBLEBROWN_BC",
        "color_hex": "#857874",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PEBBLEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27204,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "PEBBLEBROWN_BC",
        "color_hex": "#857874",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PEBBLEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27205,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "PEBBLEBROWN_BC",
        "color_hex": "#857874",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PEBBLEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27206,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "PEBBLEBROWN_BC",
        "color_hex": "#857874",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PEBBLEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27207,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "PEBBLEBROWN_BC",
        "color_hex": "#857874",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PEBBLEBROWN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 27301,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "PINE_BC",
        "color_hex": "#425E5A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27302,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "PINE_BC",
        "color_hex": "#425E5A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27303,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "PINE_BC",
        "color_hex": "#425E5A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27304,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "PINE_BC",
        "color_hex": "#425E5A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27305,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "PINE_BC",
        "color_hex": "#425E5A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27306,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "PINE_BC",
        "color_hex": "#425E5A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27307,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "PINE_BC",
        "color_hex": "#425E5A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 27401,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "PINKGRAVEL_BC",
        "color_hex": "#BFB4B1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINKGRAVEL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27402,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "PINKGRAVEL_BC",
        "color_hex": "#BFB4B1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINKGRAVEL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27403,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "PINKGRAVEL_BC",
        "color_hex": "#BFB4B1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINKGRAVEL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27404,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "PINKGRAVEL_BC",
        "color_hex": "#BFB4B1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINKGRAVEL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27405,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "PINKGRAVEL_BC",
        "color_hex": "#BFB4B1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINKGRAVEL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27406,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "PINKGRAVEL_BC",
        "color_hex": "#BFB4B1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINKGRAVEL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27407,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "PINKGRAVEL_BC",
        "color_hex": "#BFB4B1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINKGRAVEL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27501,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "PINK_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27502,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "PINK_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27503,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "PINK_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27504,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "PINK_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27505,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "PINK_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27506,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "PINK_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27507,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "PINK_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27701,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "PURPLESTORM_BC",
        "color_hex": "#6d585f",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PURPLESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27702,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "PURPLESTORM_BC",
        "color_hex": "#6d585f",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PURPLESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27703,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "PURPLESTORM_BC",
        "color_hex": "#6d585f",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PURPLESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27704,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "PURPLESTORM_BC",
        "color_hex": "#6d585f",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PURPLESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27705,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "PURPLESTORM_BC",
        "color_hex": "#6d585f",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PURPLESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27706,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "PURPLESTORM_BC",
        "color_hex": "#6d585f",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PURPLESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27707,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "PURPLESTORM_BC",
        "color_hex": "#6d585f",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/PURPLESTORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27808,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "5XL",
        "color": "RED_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27901,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "ROYALPURPLE_BC",
        "color_hex": "#714B96",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ROYALPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27902,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "ROYALPURPLE_BC",
        "color_hex": "#714B96",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ROYALPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27903,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "ROYALPURPLE_BC",
        "color_hex": "#714B96",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ROYALPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27904,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "ROYALPURPLE_BC",
        "color_hex": "#714B96",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ROYALPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27905,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "ROYALPURPLE_BC",
        "color_hex": "#714B96",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ROYALPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27906,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "ROYALPURPLE_BC",
        "color_hex": "#714B96",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ROYALPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 27907,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "ROYALPURPLE_BC",
        "color_hex": "#714B96",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/ROYALPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28001,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "RUST_BC",
        "color_hex": "#9E483F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RUST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28002,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "RUST_BC",
        "color_hex": "#9E483F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RUST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28003,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "RUST_BC",
        "color_hex": "#9E483F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RUST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28004,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "RUST_BC",
        "color_hex": "#9E483F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RUST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28005,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "RUST_BC",
        "color_hex": "#9E483F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RUST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28006,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "RUST_BC",
        "color_hex": "#9E483F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RUST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28007,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "RUST_BC",
        "color_hex": "#9E483F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/RUST_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28101,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SAGE_BC",
        "color_hex": "#96A693",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SAGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28102,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SAGE_BC",
        "color_hex": "#96A693",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SAGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28103,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SAGE_BC",
        "color_hex": "#96A693",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SAGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28104,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SAGE_BC",
        "color_hex": "#96A693",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SAGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28105,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SAGE_BC",
        "color_hex": "#96A693",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SAGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28106,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SAGE_BC",
        "color_hex": "#96A693",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SAGE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28107,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SAGE_BC",
        "color_hex": "#96A693",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SAGE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28201,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SANDDUNE_BC",
        "color_hex": "#C39D88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SANDDUNE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28202,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SANDDUNE_BC",
        "color_hex": "#C39D88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SANDDUNE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28203,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SANDDUNE_BC",
        "color_hex": "#C39D88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SANDDUNE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28204,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SANDDUNE_BC",
        "color_hex": "#C39D88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SANDDUNE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28205,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SANDDUNE_BC",
        "color_hex": "#C39D88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SANDDUNE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28206,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SANDDUNE_BC",
        "color_hex": "#C39D88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SANDDUNE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28207,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SANDDUNE_BC",
        "color_hex": "#C39D88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SANDDUNE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28301,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SILVER_BC",
        "color_hex": "#C7C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SILVER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28302,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SILVER_BC",
        "color_hex": "#C7C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SILVER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28303,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SILVER_BC",
        "color_hex": "#C7C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SILVER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28304,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SILVER_BC",
        "color_hex": "#C7C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SILVER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28305,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SILVER_BC",
        "color_hex": "#C7C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SILVER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28306,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SILVER_BC",
        "color_hex": "#C7C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SILVER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28307,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SILVER_BC",
        "color_hex": "#C7C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SILVER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28401,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SLATE_BC",
        "color_hex": "#5C6E76",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SLATE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28402,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SLATE_BC",
        "color_hex": "#5C6E76",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SLATE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28403,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SLATE_BC",
        "color_hex": "#5C6E76",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SLATE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28404,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SLATE_BC",
        "color_hex": "#5C6E76",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SLATE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28405,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SLATE_BC",
        "color_hex": "#5C6E76",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SLATE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28406,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SLATE_BC",
        "color_hex": "#5C6E76",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SLATE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28407,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SLATE_BC",
        "color_hex": "#5C6E76",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SLATE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28501,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SOFTCREAM_BC",
        "color_hex": "#DECA9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTCREAM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28502,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SOFTCREAM_BC",
        "color_hex": "#DECA9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTCREAM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28503,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SOFTCREAM_BC",
        "color_hex": "#DECA9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTCREAM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28504,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SOFTCREAM_BC",
        "color_hex": "#DECA9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTCREAM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28505,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SOFTCREAM_BC",
        "color_hex": "#DECA9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTCREAM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28506,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SOFTCREAM_BC",
        "color_hex": "#DECA9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTCREAM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28507,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SOFTCREAM_BC",
        "color_hex": "#DECA9E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTCREAM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28601,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SOFTPINK_BC",
        "color_hex": "#EFDAC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTPINK_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28602,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SOFTPINK_BC",
        "color_hex": "#EFDAC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTPINK_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28603,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SOFTPINK_BC",
        "color_hex": "#EFDAC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTPINK_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28604,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SOFTPINK_BC",
        "color_hex": "#EFDAC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28605,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SOFTPINK_BC",
        "color_hex": "#EFDAC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28606,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SOFTPINK_BC",
        "color_hex": "#EFDAC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTPINK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28607,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SOFTPINK_BC",
        "color_hex": "#EFDAC8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOFTPINK_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28701,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SOLIDATHLETICGREY_BC",
        "color_hex": "#BABCC0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOLIDATHLETICGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28702,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SOLIDATHLETICGREY_BC",
        "color_hex": "#BABCC0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOLIDATHLETICGREY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28703,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SOLIDATHLETICGREY_BC",
        "color_hex": "#BABCC0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOLIDATHLETICGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28704,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SOLIDATHLETICGREY_BC",
        "color_hex": "#BABCC0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOLIDATHLETICGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28705,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SOLIDATHLETICGREY_BC",
        "color_hex": "#BABCC0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOLIDATHLETICGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28706,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SOLIDATHLETICGREY_BC",
        "color_hex": "#BABCC0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOLIDATHLETICGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28707,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SOLIDATHLETICGREY_BC",
        "color_hex": "#BABCC0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SOLIDATHLETICGREY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SPRINGGREEN_BC",
        "color_hex": "#E3E582",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SPRINGGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SPRINGGREEN_BC",
        "color_hex": "#E3E582",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SPRINGGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SPRINGGREEN_BC",
        "color_hex": "#E3E582",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SPRINGGREEN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 28804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SPRINGGREEN_BC",
        "color_hex": "#E3E582",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SPRINGGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SPRINGGREEN_BC",
        "color_hex": "#E3E582",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SPRINGGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SPRINGGREEN_BC",
        "color_hex": "#E3E582",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SPRINGGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SPRINGGREEN_BC",
        "color_hex": "#E3E582",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SPRINGGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28901,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "STEELBLUE_BC",
        "color_hex": "#678096",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STEELBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28902,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "STEELBLUE_BC",
        "color_hex": "#678096",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STEELBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28903,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "STEELBLUE_BC",
        "color_hex": "#678096",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STEELBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28904,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "STEELBLUE_BC",
        "color_hex": "#678096",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STEELBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28905,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "STEELBLUE_BC",
        "color_hex": "#678096",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STEELBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28906,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "STEELBLUE_BC",
        "color_hex": "#678096",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STEELBLUE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 28907,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "STEELBLUE_BC",
        "color_hex": "#678096",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STEELBLUE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29001,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "STORM_BC",
        "color_hex": "#757870",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29002,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "STORM_BC",
        "color_hex": "#757870",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29003,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "STORM_BC",
        "color_hex": "#757870",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29004,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "STORM_BC",
        "color_hex": "#757870",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29005,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "STORM_BC",
        "color_hex": "#757870",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29006,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "STORM_BC",
        "color_hex": "#757870",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STORM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29007,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "STORM_BC",
        "color_hex": "#757870",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STORM_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29101,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "STROBE_BC",
        "color_hex": "#EEE971",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STROBE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29102,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "STROBE_BC",
        "color_hex": "#EEE971",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STROBE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29103,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "STROBE_BC",
        "color_hex": "#EEE971",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STROBE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29104,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "STROBE_BC",
        "color_hex": "#EEE971",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STROBE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29105,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "STROBE_BC",
        "color_hex": "#EEE971",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STROBE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29106,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "STROBE_BC",
        "color_hex": "#EEE971",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STROBE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29107,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "STROBE_BC",
        "color_hex": "#EEE971",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/STROBE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29201,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SUNSET_BC",
        "color_hex": "#E37F57",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SUNSET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29202,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SUNSET_BC",
        "color_hex": "#E37F57",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SUNSET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29203,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SUNSET_BC",
        "color_hex": "#E37F57",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SUNSET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29204,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SUNSET_BC",
        "color_hex": "#E37F57",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SUNSET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29205,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SUNSET_BC",
        "color_hex": "#E37F57",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SUNSET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29206,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SUNSET_BC",
        "color_hex": "#E37F57",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SUNSET_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29207,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SUNSET_BC",
        "color_hex": "#E37F57",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SUNSET_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29301,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "SYNTHETICGREEN_BC",
        "color_hex": "#2BAE66",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SYNTHETICGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29302,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "SYNTHETICGREEN_BC",
        "color_hex": "#2BAE66",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SYNTHETICGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29303,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "SYNTHETICGREEN_BC",
        "color_hex": "#2BAE66",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SYNTHETICGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29304,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "SYNTHETICGREEN_BC",
        "color_hex": "#2BAE66",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SYNTHETICGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29305,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "SYNTHETICGREEN_BC",
        "color_hex": "#2BAE66",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SYNTHETICGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29306,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "SYNTHETICGREEN_BC",
        "color_hex": "#2BAE66",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SYNTHETICGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29307,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "SYNTHETICGREEN_BC",
        "color_hex": "#2BAE66",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/SYNTHETICGREEN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29401,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TAN_BC",
        "color_hex": "#AEA282",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TAN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29402,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TAN_BC",
        "color_hex": "#AEA282",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TAN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29403,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TAN_BC",
        "color_hex": "#AEA282",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TAN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29404,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TAN_BC",
        "color_hex": "#AEA282",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TAN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29405,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TAN_BC",
        "color_hex": "#AEA282",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TAN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29406,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TAN_BC",
        "color_hex": "#AEA282",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TAN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29407,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TAN_BC",
        "color_hex": "#AEA282",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TAN_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29501,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TEAL_BC",
        "color_hex": "#00BFB3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29502,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TEAL_BC",
        "color_hex": "#00BFB3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29503,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TEAL_BC",
        "color_hex": "#00BFB3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29504,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TEAL_BC",
        "color_hex": "#00BFB3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29505,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TEAL_BC",
        "color_hex": "#00BFB3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29506,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TEAL_BC",
        "color_hex": "#00BFB3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29507,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TEAL_BC",
        "color_hex": "#00BFB3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAL_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 29601,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TEAMNAVY_BC",
        "color_hex": "#29306F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMNAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29602,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TEAMNAVY_BC",
        "color_hex": "#29306F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMNAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29603,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TEAMNAVY_BC",
        "color_hex": "#29306F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMNAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29604,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TEAMNAVY_BC",
        "color_hex": "#29306F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMNAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29605,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TEAMNAVY_BC",
        "color_hex": "#29306F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMNAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29606,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TEAMNAVY_BC",
        "color_hex": "#29306F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMNAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29607,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TEAMNAVY_BC",
        "color_hex": "#29306F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMNAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29701,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TEAMPURPLE_BC",
        "color_hex": "#2E1A47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29702,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TEAMPURPLE_BC",
        "color_hex": "#2E1A47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29703,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TEAMPURPLE_BC",
        "color_hex": "#2E1A47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29704,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TEAMPURPLE_BC",
        "color_hex": "#2E1A47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29705,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TEAMPURPLE_BC",
        "color_hex": "#2E1A47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29706,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TEAMPURPLE_BC",
        "color_hex": "#2E1A47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29707,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TEAMPURPLE_BC",
        "color_hex": "#2E1A47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TEAMPURPLE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TERRACOTTA_BC",
        "color_hex": "#B3684D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TERRACOTTA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TERRACOTTA_BC",
        "color_hex": "#B3684D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TERRACOTTA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TERRACOTTA_BC",
        "color_hex": "#B3684D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TERRACOTTA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TERRACOTTA_BC",
        "color_hex": "#B3684D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TERRACOTTA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TERRACOTTA_BC",
        "color_hex": "#B3684D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TERRACOTTA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TERRACOTTA_BC",
        "color_hex": "#B3684D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TERRACOTTA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TERRACOTTA_BC",
        "color_hex": "#B3684D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TERRACOTTA_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29901,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "THYME_BC",
        "color_hex": "#B6B9A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/THYME_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29902,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "THYME_BC",
        "color_hex": "#B6B9A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/THYME_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29903,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "THYME_BC",
        "color_hex": "#B6B9A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/THYME_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29904,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "THYME_BC",
        "color_hex": "#B6B9A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/THYME_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29905,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "THYME_BC",
        "color_hex": "#B6B9A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/THYME_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29906,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "THYME_BC",
        "color_hex": "#B6B9A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/THYME_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 29907,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "THYME_BC",
        "color_hex": "#B6B9A7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/THYME_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30001,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TOAST_BC",
        "color_hex": "#9E6A38",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TOAST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30002,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TOAST_BC",
        "color_hex": "#9E6A38",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TOAST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30003,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TOAST_BC",
        "color_hex": "#9E6A38",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TOAST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30004,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TOAST_BC",
        "color_hex": "#9E6A38",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TOAST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30005,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TOAST_BC",
        "color_hex": "#9E6A38",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TOAST_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30006,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TOAST_BC",
        "color_hex": "#9E6A38",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TOAST_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30007,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TOAST_BC",
        "color_hex": "#9E6A38",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TOAST_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30101,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30102,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30103,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30104,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30105,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30106,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30107,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30108,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "5XL",
        "color": "TRUEROYAL_BC",
        "color_hex": "#4C619C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TRUEROYAL_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30201,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "TURQUOISE_BC",
        "color_hex": "#00AFD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TURQUOISE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30202,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "TURQUOISE_BC",
        "color_hex": "#00AFD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TURQUOISE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30203,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "TURQUOISE_BC",
        "color_hex": "#00AFD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TURQUOISE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30204,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "TURQUOISE_BC",
        "color_hex": "#00AFD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TURQUOISE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30205,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "TURQUOISE_BC",
        "color_hex": "#00AFD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TURQUOISE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30206,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "TURQUOISE_BC",
        "color_hex": "#00AFD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TURQUOISE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30207,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "TURQUOISE_BC",
        "color_hex": "#00AFD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/TURQUOISE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30301,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "VINTAGEBLACK_BC",
        "color_hex": "#212322",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30302,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "VINTAGEBLACK_BC",
        "color_hex": "#212322",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30303,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "VINTAGEBLACK_BC",
        "color_hex": "#212322",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30304,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "VINTAGEBLACK_BC",
        "color_hex": "#212322",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30305,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "VINTAGEBLACK_BC",
        "color_hex": "#212322",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30306,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "VINTAGEBLACK_BC",
        "color_hex": "#212322",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30307,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "VINTAGEBLACK_BC",
        "color_hex": "#212322",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBLACK_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30401,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "VINTAGEBROWN_BC",
        "color_hex": "#86715A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30402,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "VINTAGEBROWN_BC",
        "color_hex": "#86715A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30403,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "VINTAGEBROWN_BC",
        "color_hex": "#86715A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30404,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "VINTAGEBROWN_BC",
        "color_hex": "#86715A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30405,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "VINTAGEBROWN_BC",
        "color_hex": "#86715A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30406,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "VINTAGEBROWN_BC",
        "color_hex": "#86715A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30407,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "VINTAGEBROWN_BC",
        "color_hex": "#86715A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEBROWN_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30501,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "VINTAGEDENIM_BC",
        "color_hex": "#7D98A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEDENIM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30502,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "VINTAGEDENIM_BC",
        "color_hex": "#7D98A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEDENIM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30503,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "VINTAGEDENIM_BC",
        "color_hex": "#7D98A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEDENIM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30504,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "VINTAGEDENIM_BC",
        "color_hex": "#7D98A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEDENIM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30505,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "VINTAGEDENIM_BC",
        "color_hex": "#7D98A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEDENIM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30506,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "VINTAGEDENIM_BC",
        "color_hex": "#7D98A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEDENIM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30507,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "VINTAGEDENIM_BC",
        "color_hex": "#7D98A3",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEDENIM_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30601,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "VINTAGENAVY_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGENAVY_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30602,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "VINTAGENAVY_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGENAVY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30603,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "VINTAGENAVY_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGENAVY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30604,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "VINTAGENAVY_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGENAVY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30605,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "VINTAGENAVY_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGENAVY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30606,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "VINTAGENAVY_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGENAVY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30607,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "VINTAGENAVY_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGENAVY_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30701,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "VINTAGERED_BC",
        "color_hex": "#C46069",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGERED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30702,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "VINTAGERED_BC",
        "color_hex": "#C46069",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGERED_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30703,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "VINTAGERED_BC",
        "color_hex": "#C46069",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGERED_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30704,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "VINTAGERED_BC",
        "color_hex": "#C46069",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGERED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30705,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "VINTAGERED_BC",
        "color_hex": "#C46069",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGERED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30706,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "VINTAGERED_BC",
        "color_hex": "#C46069",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGERED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30707,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "VINTAGERED_BC",
        "color_hex": "#C46069",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGERED_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30801,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "VINTAGEWHITE_BC",
        "color_hex": "#DFDDD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEWHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30802,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "VINTAGEWHITE_BC",
        "color_hex": "#DFDDD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEWHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30803,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "VINTAGEWHITE_BC",
        "color_hex": "#DFDDD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEWHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30804,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "VINTAGEWHITE_BC",
        "color_hex": "#DFDDD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEWHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30805,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "VINTAGEWHITE_BC",
        "color_hex": "#DFDDD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEWHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30806,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "VINTAGEWHITE_BC",
        "color_hex": "#DFDDD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEWHITE_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30807,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "VINTAGEWHITE_BC",
        "color_hex": "#DFDDD7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/VINTAGEWHITE_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30901,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "S",
        "color": "YELLOW_BC",
        "color_hex": "#F6EB69",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/YELLOW_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30902,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "M",
        "color": "YELLOW_BC",
        "color_hex": "#F6EB69",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/YELLOW_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30903,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "L",
        "color": "YELLOW_BC",
        "color_hex": "#F6EB69",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/YELLOW_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30904,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "XL",
        "color": "YELLOW_BC",
        "color_hex": "#F6EB69",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/YELLOW_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30905,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "2XL",
        "color": "YELLOW_BC",
        "color_hex": "#F6EB69",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/YELLOW_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 30906,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "3XL",
        "color": "YELLOW_BC",
        "color_hex": "#F6EB69",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/YELLOW_BC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 30907,
        "product_type": "SHIRT",
        "brand": "BELLA",
        "style": "B3001",
        "size": "4XL",
        "color": "YELLOW_BC",
        "color_hex": "#F6EB69",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/B3001/YELLOW_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31001,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BANANA_CC",
        "color_hex": "#F1E6B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BANANA_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31101,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BERRY_CC",
        "color_hex": "#7E4966",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31102,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BERRY_CC",
        "color_hex": "#7E4966",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31103,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BERRY_CC",
        "color_hex": "#7E4966",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31104,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BERRY_CC",
        "color_hex": "#7E4966",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31105,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BERRY_CC",
        "color_hex": "#7E4966",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31106,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BERRY_CC",
        "color_hex": "#7E4966",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31107,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BERRY_CC",
        "color_hex": "#7E4966",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BERRY_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31301,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31302,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRICK_CC.jpeg",
        "stock": "Out Of Stock Soon"
    },
    {
        "variant_id": 31303,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31304,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRICK_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31305,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31306,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31307,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRICK_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31401,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BRIGHTORANGE_CC",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRIGHTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31402,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BRIGHTORANGE_CC",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRIGHTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31403,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BRIGHTORANGE_CC",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRIGHTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31404,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BRIGHTORANGE_CC",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRIGHTORANGE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31405,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BRIGHTORANGE_CC",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRIGHTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31406,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BRIGHTORANGE_CC",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRIGHTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31407,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BRIGHTORANGE_CC",
        "color_hex": "#FF8200",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BRIGHTORANGE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31601,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BURNTORANGE_CC",
        "color_hex": "#FF6900",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BURNTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31602,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BURNTORANGE_CC",
        "color_hex": "#FF6900",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BURNTORANGE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31603,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BURNTORANGE_CC",
        "color_hex": "#FF6900",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BURNTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31604,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BURNTORANGE_CC",
        "color_hex": "#FF6900",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BURNTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31605,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BURNTORANGE_CC",
        "color_hex": "#FF6900",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BURNTORANGE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31606,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BURNTORANGE_CC",
        "color_hex": "#FF6900",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BURNTORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31607,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BURNTORANGE_CC",
        "color_hex": "#FF6900",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BURNTORANGE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31701,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "BUTTER_CC",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BUTTER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31702,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "BUTTER_CC",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BUTTER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31703,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "BUTTER_CC",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BUTTER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31704,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "BUTTER_CC",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BUTTER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31705,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "BUTTER_CC",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BUTTER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31706,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "BUTTER_CC",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BUTTER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31707,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "BUTTER_CC",
        "color_hex": "#F5E1A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/BUTTER_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31801,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31802,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31803,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31804,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31805,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31807,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHALKYMINT_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 31901,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31902,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31903,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31904,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31905,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31906,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 31907,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHAMBRAY_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 32003,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "CHILI_CC",
        "color_hex": "#893C47",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CHILI_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32301,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32302,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32303,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32304,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32305,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32306,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32307,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/CRUNCHBERRY_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 32401,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32402,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32403,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32404,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32405,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32406,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32407,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/DENIM_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 32601,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32602,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32603,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32604,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32605,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32606,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32607,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/FLOBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 32702,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "GRANITE_CC",
        "color_hex": "#7C878E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRANITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32703,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "GRANITE_CC",
        "color_hex": "#7C878E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRANITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32704,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "GRANITE_CC",
        "color_hex": "#7C878E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRANITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32705,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "GRANITE_CC",
        "color_hex": "#7C878E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRANITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32706,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "GRANITE_CC",
        "color_hex": "#7C878E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRANITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32707,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "GRANITE_CC",
        "color_hex": "#7C878E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRANITE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 32801,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32802,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32803,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32804,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32805,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32806,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 32807,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/GRAPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 33303,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "ICEBLUE_CC",
        "color_hex": "#5B7F95",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ICEBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33501,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "ISLANDREEF_CC",
        "color_hex": "#8FE2B0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ISLANDREEF_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33502,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "ISLANDREEF_CC",
        "color_hex": "#8FE2B0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ISLANDREEF_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33503,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "ISLANDREEF_CC",
        "color_hex": "#8FE2B0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ISLANDREEF_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33504,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "ISLANDREEF_CC",
        "color_hex": "#8FE2B0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ISLANDREEF_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33505,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "ISLANDREEF_CC",
        "color_hex": "#8FE2B0",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ISLANDREEF_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33601,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "KHAKI_CC",
        "color_hex": "#A09074",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/KHAKI_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33602,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "KHAKI_CC",
        "color_hex": "#A09074",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/KHAKI_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33603,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "KHAKI_CC",
        "color_hex": "#A09074",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/KHAKI_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33604,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "KHAKI_CC",
        "color_hex": "#A09074",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/KHAKI_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33605,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "KHAKI_CC",
        "color_hex": "#A09074",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/KHAKI_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33606,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "KHAKI_CC",
        "color_hex": "#A09074",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/KHAKI_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33607,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "KHAKI_CC",
        "color_hex": "#A09074",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/KHAKI_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 33701,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33702,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33703,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33704,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33705,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33706,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33707,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LAGOONBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 33801,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33802,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33803,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33804,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33805,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33806,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33807,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/LIGHTGREEN_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 33903,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "MELON_CC",
        "color_hex": "#FA9370",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 33904,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "MELON_CC",
        "color_hex": "#FA9370",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34001,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "MIDNIGHT_CC",
        "color_hex": "#1B365D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MIDNIGHT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34002,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "MIDNIGHT_CC",
        "color_hex": "#1B365D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MIDNIGHT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34003,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "MIDNIGHT_CC",
        "color_hex": "#1B365D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MIDNIGHT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34004,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "MIDNIGHT_CC",
        "color_hex": "#1B365D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MIDNIGHT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34005,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "MIDNIGHT_CC",
        "color_hex": "#1B365D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MIDNIGHT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34006,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "MIDNIGHT_CC",
        "color_hex": "#1B365D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MIDNIGHT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34007,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "MIDNIGHT_CC",
        "color_hex": "#1B365D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MIDNIGHT_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34102,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "MUSTARD_CC",
        "color_hex": "#F2CD00",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MUSTARD_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34103,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "MUSTARD_CC",
        "color_hex": "#F2CD00",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MUSTARD_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34104,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "MUSTARD_CC",
        "color_hex": "#F2CD00",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/MUSTARD_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34301,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "NAVY_CC",
        "color_hex": "#0C2340",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34302,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "NAVY_CC",
        "color_hex": "#0C2340",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34303,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "NAVY_CC",
        "color_hex": "#0C2340",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34304,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "NAVY_CC",
        "color_hex": "#0C2340",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34305,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "NAVY_CC",
        "color_hex": "#0C2340",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34306,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "NAVY_CC",
        "color_hex": "#0C2340",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34307,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "NAVY_CC",
        "color_hex": "#0C2340",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NAVY_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34501,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "NEONCANTALOUPE_CC",
        "color_hex": "#FFBBA4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONCANTALOUPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34502,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "NEONCANTALOUPE_CC",
        "color_hex": "#FFBBA4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONCANTALOUPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34503,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "NEONCANTALOUPE_CC",
        "color_hex": "#FFBBA4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONCANTALOUPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34504,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "NEONCANTALOUPE_CC",
        "color_hex": "#FFBBA4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONCANTALOUPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34505,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "NEONCANTALOUPE_CC",
        "color_hex": "#FFBBA4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONCANTALOUPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34506,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "NEONCANTALOUPE_CC",
        "color_hex": "#FFBBA4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONCANTALOUPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34507,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "NEONCANTALOUPE_CC",
        "color_hex": "#FFBBA4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONCANTALOUPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34601,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "NEONLEMON_CC",
        "color_hex": "#EFF4A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONLEMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34602,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "NEONLEMON_CC",
        "color_hex": "#EFF4A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONLEMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34603,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "NEONLEMON_CC",
        "color_hex": "#EFF4A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONLEMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34604,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "NEONLEMON_CC",
        "color_hex": "#EFF4A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONLEMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34605,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "NEONLEMON_CC",
        "color_hex": "#EFF4A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONLEMON_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34606,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "NEONLEMON_CC",
        "color_hex": "#EFF4A4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONLEMON_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34701,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34702,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34703,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34704,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34705,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34706,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34801,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34802,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34803,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34804,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34805,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34806,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34901,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "NEONVIOLET_CC",
        "color_hex": "#BF9BDE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONVIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34902,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "NEONVIOLET_CC",
        "color_hex": "#BF9BDE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONVIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34903,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "NEONVIOLET_CC",
        "color_hex": "#BF9BDE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONVIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34904,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "NEONVIOLET_CC",
        "color_hex": "#BF9BDE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONVIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34905,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "NEONVIOLET_CC",
        "color_hex": "#BF9BDE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONVIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 34906,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "NEONVIOLET_CC",
        "color_hex": "#BF9BDE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONVIOLET_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 34907,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "NEONVIOLET_CC",
        "color_hex": "#BF9BDE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/NEONVIOLET_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 35001,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "ORCHID_CC",
        "color_hex": "#C7B2DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ORCHID_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35002,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "ORCHID_CC",
        "color_hex": "#C7B2DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ORCHID_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35003,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "ORCHID_CC",
        "color_hex": "#C7B2DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ORCHID_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35004,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "ORCHID_CC",
        "color_hex": "#C7B2DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ORCHID_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35005,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "ORCHID_CC",
        "color_hex": "#C7B2DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ORCHID_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35006,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "ORCHID_CC",
        "color_hex": "#C7B2DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/ORCHID_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35401,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "RED_CC",
        "color_hex": "#C8102E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/RED_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35402,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "RED_CC",
        "color_hex": "#C8102E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/RED_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35403,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "RED_CC",
        "color_hex": "#C8102E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/RED_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35404,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "RED_CC",
        "color_hex": "#C8102E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/RED_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35405,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "RED_CC",
        "color_hex": "#C8102E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/RED_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35406,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "RED_CC",
        "color_hex": "#C8102E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/RED_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35407,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "RED_CC",
        "color_hex": "#C8102E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/RED_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 35601,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "SAGE_CC",
        "color_hex": "#3E4827",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35602,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "SAGE_CC",
        "color_hex": "#3E4827",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35603,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "SAGE_CC",
        "color_hex": "#3E4827",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35604,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "SAGE_CC",
        "color_hex": "#3E4827",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35605,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "SAGE_CC",
        "color_hex": "#3E4827",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35606,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "SAGE_CC",
        "color_hex": "#3E4827",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35607,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "SAGE_CC",
        "color_hex": "#3E4827",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAGE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 35701,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35702,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35703,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35704,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35705,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35706,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35707,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SANDSTONE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 35801,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35802,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35803,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35804,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35805,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35806,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35807,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/SAPPHIRE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 35901,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "TERRACOTTA_CC",
        "color_hex": "#E3775E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TERRACOTTA_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35902,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "TERRACOTTA_CC",
        "color_hex": "#E3775E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TERRACOTTA_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 35903,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "TERRACOTTA_CC",
        "color_hex": "#E3775E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TERRACOTTA_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35904,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "TERRACOTTA_CC",
        "color_hex": "#E3775E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TERRACOTTA_CC.jpeg",
        "stock": "Out Of Stock Soon"
    },
    {
        "variant_id": 35905,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "TERRACOTTA_CC",
        "color_hex": "#E3775E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TERRACOTTA_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35906,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "TERRACOTTA_CC",
        "color_hex": "#E3775E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TERRACOTTA_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 35907,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "TERRACOTTA_CC",
        "color_hex": "#E3775E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TERRACOTTA_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36001,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "TOPAZBLUE_CC",
        "color_hex": "#006980",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TOPAZBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36002,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "TOPAZBLUE_CC",
        "color_hex": "#006980",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TOPAZBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36003,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "TOPAZBLUE_CC",
        "color_hex": "#006980",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TOPAZBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36004,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "TOPAZBLUE_CC",
        "color_hex": "#006980",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TOPAZBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36005,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "TOPAZBLUE_CC",
        "color_hex": "#006980",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TOPAZBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36006,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "TOPAZBLUE_CC",
        "color_hex": "#006980",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TOPAZBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36007,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "TOPAZBLUE_CC",
        "color_hex": "#006980",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TOPAZBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36101,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36102,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36103,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36104,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36105,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36106,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36107,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/TRUENAVY_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36201,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "VINEYARD_CC",
        "color_hex": "#672146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VINEYARD_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36202,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "VINEYARD_CC",
        "color_hex": "#672146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VINEYARD_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36203,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "VINEYARD_CC",
        "color_hex": "#672146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VINEYARD_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36204,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "VINEYARD_CC",
        "color_hex": "#672146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VINEYARD_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36205,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "VINEYARD_CC",
        "color_hex": "#672146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VINEYARD_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36206,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "VINEYARD_CC",
        "color_hex": "#672146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VINEYARD_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36207,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "VINEYARD_CC",
        "color_hex": "#672146",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/VINEYARD_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36301,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "WASHEDDENIM_CC",
        "color_hex": "#6787B7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WASHEDDENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36302,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "WASHEDDENIM_CC",
        "color_hex": "#6787B7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WASHEDDENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36304,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "WASHEDDENIM_CC",
        "color_hex": "#6787B7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WASHEDDENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36305,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "WASHEDDENIM_CC",
        "color_hex": "#6787B7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WASHEDDENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36306,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "WASHEDDENIM_CC",
        "color_hex": "#6787B7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WASHEDDENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36307,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "WASHEDDENIM_CC",
        "color_hex": "#6787B7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WASHEDDENIM_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36401,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36402,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36403,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36404,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36405,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36406,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36407,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WATERMELON_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36501,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "WINE_CC",
        "color_hex": "#51284F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WINE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36502,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "WINE_CC",
        "color_hex": "#51284F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WINE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36503,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "WINE_CC",
        "color_hex": "#51284F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WINE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36504,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "WINE_CC",
        "color_hex": "#51284F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WINE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36505,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "WINE_CC",
        "color_hex": "#51284F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WINE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36506,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "WINE_CC",
        "color_hex": "#51284F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WINE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36507,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "WINE_CC",
        "color_hex": "#51284F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/WINE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36601,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "S",
        "color": "YAM_CC",
        "color_hex": "#BE531C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/YAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36602,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "M",
        "color": "YAM_CC",
        "color_hex": "#BE531C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/YAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36603,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "L",
        "color": "YAM_CC",
        "color_hex": "#BE531C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/YAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36604,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "XL",
        "color": "YAM_CC",
        "color_hex": "#BE531C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/YAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36605,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "2XL",
        "color": "YAM_CC",
        "color_hex": "#BE531C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/YAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36606,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "3XL",
        "color": "YAM_CC",
        "color_hex": "#BE531C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/YAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36607,
        "product_type": "SHIRT",
        "brand": "COMFORT",
        "style": "C1717",
        "size": "4XL",
        "color": "YAM_CC",
        "color_hex": "#BE531C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/C1717/YAM_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36701,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36702,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36703,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36704,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36705,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36706,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36707,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36708,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 36901,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36902,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36903,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36904,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36905,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36906,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36907,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 36908,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ASHGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37001,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/AZALEA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 37002,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37003,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37004,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37005,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37006,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37201,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37202,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37203,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37204,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37205,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37206,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37301,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37302,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37303,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37304,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37305,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37306,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37307,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37308,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37501,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37502,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37503,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37504,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37505,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37506,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37507,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37508,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKCHOCOLATE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 37601,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37602,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37603,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37604,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37605,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37606,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37607,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37608,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37801,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37802,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37803,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37804,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37805,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 37806,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 37807,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 37808,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38001,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38002,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38003,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38004,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38005,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38006,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38101,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38102,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38103,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38104,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38105,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKMAROON_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38106,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKMAROON_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38201,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38202,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38203,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38204,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38205,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38206,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDARKNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38301,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38302,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38303,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38304,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38305,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38306,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38401,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERSCARLETRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38402,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERSCARLETRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38403,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERSCARLETRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38404,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERSCARLETRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38405,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERSCARLETRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38406,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/HEATHERSCARLETRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38701,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38702,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38703,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38704,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38705,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38706,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38707,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38708,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/IRISHGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38801,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38802,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38803,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38804,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38805,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38806,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38807,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 38808,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38901,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38902,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38903,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38904,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38905,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38906,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38907,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 38908,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39001,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39002,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39003,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39004,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39005,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39006,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39007,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39008,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "MILITARYGREEN_GD",
        "color_hex": "#5E7461",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MILITARYGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39101,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39102,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39103,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39104,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39105,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39106,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/MINTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39301,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39302,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39303,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39304,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39305,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39306,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39307,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 39308,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORANGE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 39401,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "ORCHID_GD",
        "color_hex": "#C5B4E3",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39402,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "ORCHID_GD",
        "color_hex": "#C5B4E3",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39403,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "ORCHID_GD",
        "color_hex": "#C5B4E3",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39404,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "ORCHID_GD",
        "color_hex": "#C5B4E3",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39405,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "ORCHID_GD",
        "color_hex": "#C5B4E3",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORCHID_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39406,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "ORCHID_GD",
        "color_hex": "#C5B4E3",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ORCHID_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 39501,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39502,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39503,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39504,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39505,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39506,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39507,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39508,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/PURPLE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 39601,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39602,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39603,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39604,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39605,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39606,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39607,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39608,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39701,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39702,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39703,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39704,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39705,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39706,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39707,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 39708,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "ROYAL_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/ROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39901,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39902,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39903,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39904,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39905,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39906,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 39907,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 39908,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SORANGE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40011,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40012,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40013,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40014,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40015,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40016,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40101,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40102,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40103,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40104,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40105,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40106,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40107,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "4XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40108,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "5XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/SAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40201,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "S",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40202,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "M",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40203,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "L",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40204,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40205,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "2XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40206,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500",
        "size": "3XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40301,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40302,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40303,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40304,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40305,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40306,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40307,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40308,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "ANTIQUECHERRYRED_GD",
        "color_hex": "#971B2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/ANTIQUECHERRYRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 40401,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40402,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40403,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40404,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40405,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40406,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CARDINALRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40501,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40502,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40503,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40504,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40505,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40506,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40601,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40602,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40603,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40604,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40605,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40606,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40607,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40608,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40701,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "CHERRYRED_GD",
        "color_hex": "#AC2B37",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40702,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "CHERRYRED_GD",
        "color_hex": "#AC2B37",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40703,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "CHERRYRED_GD",
        "color_hex": "#AC2B37",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40704,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "CHERRYRED_GD",
        "color_hex": "#AC2B37",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40705,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "CHERRYRED_GD",
        "color_hex": "#AC2B37",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40706,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "CHERRYRED_GD",
        "color_hex": "#AC2B37",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/CHERRYRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40801,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40802,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40803,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40804,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40805,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40806,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40807,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 40808,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "DARKCHOCOLATE_GD",
        "color_hex": "#382F2D",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/DARKCHOCOLATE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41001,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41002,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41003,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41004,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41005,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41006,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41201,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41202,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41203,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41204,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41205,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41206,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "HEATHERDARKGREEN_GD",
        "color_hex": "#43695B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41301,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41302,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41303,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41304,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41305,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41306,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "HEATHERDARKMAROON_GD",
        "color_hex": "#651D32",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKMAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41401,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41402,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41403,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41404,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41405,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41406,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "HEATHERDARKNAVY_GD",
        "color_hex": "#595478",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDARKNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41501,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41502,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 41503,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41504,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41505,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41506,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "HEATHERDEEPROYAL_GD",
        "color_hex": "#1D4F91",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERDEEPROYAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41601,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERSCARLETRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41602,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERSCARLETRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41603,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERSCARLETRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41604,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERSCARLETRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41605,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERSCARLETRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41606,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "HEATHERSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HEATHERSCARLETRED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41701,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41702,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41703,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41704,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41705,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41706,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41707,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41708,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41801,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41802,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41803,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41804,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41805,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41806,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "INDIGOBLUE_GD",
        "color_hex": "#486D87",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/INDIGOBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41901,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41902,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41903,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41904,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41905,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41906,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41907,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "4XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 41908,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "5XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/IRISHGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 42001,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42002,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42003,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42004,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42005,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42006,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42101,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42102,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42103,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42104,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42105,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42106,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42301,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42302,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42303,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42304,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42305,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42306,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "SORANGE_GD",
        "color_hex": "#E5801C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42401,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42402,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42403,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42404,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42405,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42406,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42501,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "S",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42502,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "M",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42503,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "L",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42504,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42505,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "2XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42506,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000",
        "size": "3XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42600,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "ATHLETICHEATHER_BC",
        "color_hex": "#ACB1A6",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/ATHLETICHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42610,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDBABYBLUEBLEND_BC",
        "color_hex": "#89B2BD",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBABYBLUEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42620,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDBLACKBLEND_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBLACKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42630,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDNATURALBLEND_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNATURALBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42640,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDNAVYBLEND_BC",
        "color_hex": "#1F2A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42650,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDPINKBLEND_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDPINKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42660,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDREDBLEND_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDREDBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42670,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDWHITEBLEND_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDWHITEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42601,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "ATHLETICHEATHER_BC",
        "color_hex": "#ACB1A6",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/ATHLETICHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42611,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDBABYBLUEBLEND_BC",
        "color_hex": "#89B2BD",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBABYBLUEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42621,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDBLACKBLEND_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBLACKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42631,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDNATURALBLEND_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNATURALBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42641,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDNAVYBLEND_BC",
        "color_hex": "#1F2A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42651,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDPINKBLEND_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDPINKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42661,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDREDBLEND_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDREDBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42671,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDWHITEBLEND_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDWHITEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42602,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "ATHLETICHEATHER_BC",
        "color_hex": "#ACB1A6",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/ATHLETICHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42612,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDBABYBLUEBLEND_BC",
        "color_hex": "#89B2BD",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBABYBLUEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42622,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDBLACKBLEND_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBLACKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42632,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDNATURALBLEND_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNATURALBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42642,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDNAVYBLEND_BC",
        "color_hex": "#1F2A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42652,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDPINKBLEND_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDPINKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42662,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDREDBLEND_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDREDBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42672,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDWHITEBLEND_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDWHITEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42603,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "ATHLETICHEATHER_BC",
        "color_hex": "#ACB1A6",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/ATHLETICHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42613,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDBABYBLUEBLEND_BC",
        "color_hex": "#89B2BD",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBABYBLUEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42623,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDBLACKBLEND_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBLACKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42633,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDNATURALBLEND_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNATURALBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42643,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDNAVYBLEND_BC",
        "color_hex": "#1F2A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42653,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDPINKBLEND_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDPINKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42663,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDREDBLEND_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDREDBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42673,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDWHITEBLEND_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDWHITEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42604,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "ATHLETICHEATHER_BC",
        "color_hex": "#ACB1A6",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/ATHLETICHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42614,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDBABYBLUEBLEND_BC",
        "color_hex": "#89B2BD",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBABYBLUEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42624,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDBLACKBLEND_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBLACKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42634,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDNATURALBLEND_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNATURALBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42644,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDNAVYBLEND_BC",
        "color_hex": "#1F2A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42654,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDPINKBLEND_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDPINKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42664,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDREDBLEND_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDREDBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42674,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDWHITEBLEND_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDWHITEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42605,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "ATHLETICHEATHER_BC",
        "color_hex": "#ACB1A6",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/ATHLETICHEATHER_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42615,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDBABYBLUEBLEND_BC",
        "color_hex": "#89B2BD",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBABYBLUEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42625,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDBLACKBLEND_BC",
        "color_hex": "#2D2926",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDBLACKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42635,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDNATURALBLEND_BC",
        "color_hex": "#E2D0A0",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNATURALBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42645,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDNAVYBLEND_BC",
        "color_hex": "#1F2A44",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDNAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42655,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDPINKBLEND_BC",
        "color_hex": "#F7CED7",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDPINKBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42665,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDREDBLEND_BC",
        "color_hex": "#BA0C2F",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDREDBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 42675,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDWHITEBLEND_BC",
        "color_hex": "#F2F0EF",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDWHITEBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45680,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45690,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45700,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45710,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45720,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45730,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45740,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45750,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45760,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45770,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XS",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45681,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45691,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45701,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45711,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45721,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45731,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45741,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45751,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45761,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45771,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45682,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45692,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45702,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45712,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45722,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45732,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45742,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45752,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45762,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45772,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45683,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45693,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45703,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45713,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/MAROON_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45723,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45733,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45743,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45753,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45763,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45773,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45684,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45694,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45704,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45714,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45724,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45734,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45744,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45754,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "SAFETYPINK_GD",
        "color_hex": "#E16F8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SAFETYPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45764,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45774,
        "product_type": "SWEATSHIRT",
        "brand": "GILDAN",
        "style": "G18000B",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SWEATSHIRT/G18000B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45790,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45800,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CARDINALRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45810,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45820,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CHARCOAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45830,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45840,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45850,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45860,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45880,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/HELICONIA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45890,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45900,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45910,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/MAROON_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45920,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45930,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45940,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45950,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45960,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45970,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45980,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/VIOLET_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45990,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XS",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45791,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45801,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CARDINALRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45811,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45821,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45831,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45841,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45851,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45861,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45871,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "HEATHERSPORTSCARLETRED_GD",
        "color_hex": "#B83A4B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/HEATHERSPORTSCARLETRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45881,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45891,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45901,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45911,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45921,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45931,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45941,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45951,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45961,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45971,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45981,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/VIOLET_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45991,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45782,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/AZALEA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45792,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45802,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CARDINALRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45812,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45822,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45832,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45842,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45852,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45862,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45882,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45892,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45902,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45912,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45922,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/NAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45932,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45942,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45952,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45962,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45972,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45982,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/VIOLET_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45992,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45783,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/AZALEA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45793,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45803,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CARDINALRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45813,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45823,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45833,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45843,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45853,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45863,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45883,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45893,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45903,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45913,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45923,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45933,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45943,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45953,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45963,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45973,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45983,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/VIOLET_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45993,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45784,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/AZALEA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45794,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45804,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "CARDINALRED_GD",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CARDINALRED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45814,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45824,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45834,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45844,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45854,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GOLD_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45864,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/GRAPHITEHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45884,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/HELICONIA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45894,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/IRISHGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45904,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45914,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45924,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45934,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45944,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45954,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45964,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45974,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 45984,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/VIOLET_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 45994,
        "product_type": "HOODIE",
        "brand": "GILDAN",
        "style": "G18500B",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/HOODIE/G18500B/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46400,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AQUATIC_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46410,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ASHGREY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46420,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46430,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46440,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46450,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46460,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46470,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "CORALSILK_GD",
        "color_hex": "#FB637E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CORALSILK_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46480,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46490,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46500,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46510,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/FORESTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46520,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46530,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GRAPHITEHEATHER_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46540,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46550,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46560,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46570,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46580,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46590,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46600,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46610,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46620,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46630,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46640,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46650,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46660,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/RED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46670,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46680,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46690,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46700,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46710,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46720,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "S",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46401,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AQUATIC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46411,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ASHGREY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46421,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46431,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46441,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46451,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46461,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46471,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "CORALSILK_GD",
        "color_hex": "#FB637E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CORALSILK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46481,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46491,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46501,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46511,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/FORESTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46521,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46531,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GRAPHITEHEATHER_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46541,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46551,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46561,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46571,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46581,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46591,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46601,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46611,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46621,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46631,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46641,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46651,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46661,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/RED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46671,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46681,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46691,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46701,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46711,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46721,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "M",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46402,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AQUATIC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46412,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ASHGREY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46422,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46432,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46442,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46452,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46462,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46472,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "CORALSILK_GD",
        "color_hex": "#FB637E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CORALSILK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46482,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46492,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46502,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46512,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/FORESTGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46522,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46532,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GRAPHITEHEATHER_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46542,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46552,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46562,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46572,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46582,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46592,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46602,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MAROON_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46612,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46622,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46632,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46642,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46652,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46662,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46672,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46682,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46692,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46702,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46712,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46722,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "L",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46403,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AQUATIC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46413,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ASHGREY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46423,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46433,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46443,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46453,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46463,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46473,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "CORALSILK_GD",
        "color_hex": "#FB637E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CORALSILK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46483,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46493,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46503,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46513,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/FORESTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46523,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46533,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GRAPHITEHEATHER_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46543,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERNAVY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46553,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46563,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46573,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46583,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46593,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46603,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46613,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46623,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46633,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46643,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46653,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46663,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/RED_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46673,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46683,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46693,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46703,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46713,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46723,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46404,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AQUATIC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46414,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ASHGREY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46424,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AZALEA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46434,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46444,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46454,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CAROLINABLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46464,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CHARCOAL_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46474,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "CORALSILK_GD",
        "color_hex": "#FB637E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CORALSILK_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46484,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DAISY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46494,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46504,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46514,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/FORESTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46524,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46534,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GRAPHITEHEATHER_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46544,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46554,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46564,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46574,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46584,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46594,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTPINK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46604,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46614,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46624,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46634,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46644,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46654,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46664,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46674,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46684,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SAPPHIRE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46694,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46704,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46714,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/VIOLET_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46724,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "2XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46405,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "AQUATIC_GD",
        "color_hex": "#6DA29E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AQUATIC_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46415,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "ASHGREY_GD",
        "color_hex": "#C8C9C7",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ASHGREY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46425,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "AZALEA_GD",
        "color_hex": "#DD74A1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/AZALEA_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46435,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "BLACK_GD",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLACK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46445,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "BLUEDUSK_GD",
        "color_hex": "#253746",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/BLUEDUSK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46455,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "CAROLINABLUE_GD",
        "color_hex": "#7BA4DB",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CAROLINABLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46465,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "CHARCOAL_GD",
        "color_hex": "#66676C",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CHARCOAL_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46475,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "CORALSILK_GD",
        "color_hex": "#FB637E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/CORALSILK_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46485,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "DAISY_GD",
        "color_hex": "#FED141",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DAISY_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46495,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "DARKHEATHER_GD",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DARKHEATHER_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46505,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "DUSTYROSE_GD",
        "color_hex": "#E1BBB4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/DUSTYROSE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46515,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "FORESTGREEN_GD",
        "color_hex": "#273B33",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/FORESTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46525,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "GOLD_GD",
        "color_hex": "#EEAD1A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GOLD_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46535,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "GRAPHITEHEATHER_GD",
        "color_hex": "#707372",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/GRAPHITEHEATHER_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46545,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "HEATHERNAVY_GD",
        "color_hex": "#333F48",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERNAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46555,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "HEATHERSAPPHIRE_GD",
        "color_hex": "#0076A8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HEATHERSAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46565,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "HELICONIA_GD",
        "color_hex": "#DB3E79",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/HELICONIA_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46575,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "IRISHGREEN_GD",
        "color_hex": "#00A74A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/IRISHGREEN_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46585,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "LIGHTBLUE_GD",
        "color_hex": "#A4C8E1",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46595,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "LIGHTPINK_GD",
        "color_hex": "#E4C6D4",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/LIGHTPINK_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46605,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "MAROON_GD",
        "color_hex": "#5B2B42",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MAROON_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46615,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "MINTGREEN_GD",
        "color_hex": "#A0CFA8",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/MINTGREEN_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46625,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "NAVY_GD",
        "color_hex": "#263147",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/NAVY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46635,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "OFFWHITE_GD",
        "color_hex": "#F5ECD2",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/OFFWHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46645,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "ORANGE_GD",
        "color_hex": "#F4633A",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ORANGE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46655,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "PURPLE_GD",
        "color_hex": "#47247E",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/PURPLE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46665,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "RED_GD",
        "color_hex": "#D50032",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/RED_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46675,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "ROYALBLUE_GD",
        "color_hex": "#224D8F",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/ROYALBLUE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46685,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "SAPPHIRE_GD",
        "color_hex": "#0077B5",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SAPPHIRE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46695,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "SPORTGREY_GD",
        "color_hex": "#97999B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/SPORTGREY_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 46705,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "TROPICALBLUE_GD",
        "color_hex": "#00859B",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/TROPICALBLUE_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46715,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "VIOLET_GD",
        "color_hex": "#8094DD",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/VIOLET_GD.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 46725,
        "product_type": "SHIRT",
        "brand": "GILDAN",
        "style": "G5000L",
        "size": "3XL",
        "color": "WHITE_GD",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/SHIRT/G5000L/WHITE_GD.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51102,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "5.5x5.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51103,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0021S",
        "size": "4.25x3",
        "color": "Medallion_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/A0021S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51104,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0021S",
        "size": "5.25x3.7",
        "color": "Medallion_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/A0021S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51105,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0021SL",
        "size": "6.25x4.4",
        "color": "Medallion_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/A0021SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51106,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0011S",
        "size": "3x3",
        "color": "Circle_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/A0011S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51107,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0011S",
        "size": "4x4",
        "color": "Circle_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/A0011S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51108,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0011SL",
        "size": "5x5",
        "color": "Circle_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/A0011SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 52109,
        "product_type": "ORNAMENT",
        "brand": "CERAMIC",
        "style": "C0011S",
        "size": "3x3",
        "color": "Circle_Ceramic",
        "product_image": "https://flashship.net/productImage/INTROn/C0011S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 52110,
        "product_type": "ORNAMENT",
        "brand": "CERAMIC",
        "style": "C0031S",
        "size": "3x3",
        "color": "Heart_Ceramic",
        "product_image": "https://flashship.net/productImage/INTROn/C0031S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53111,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "3.5x3.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53112,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "4.5x4.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53113,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53103,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0021S",
        "size": "4.25x3",
        "color": "Medallion_Wooden",
        "product_image": "https://flashship.net/productImage/INTROn/W0021S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53104,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0021S",
        "size": "5.25x3.7",
        "color": "Medallion_Wooden",
        "product_image": "https://flashship.net/productImage/INTROn/W0021S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53105,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0021SL",
        "size": "6.25x4.4",
        "color": "Medallion_Wooden",
        "product_image": "https://flashship.net/productImage/INTROn/W0021SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53106,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0011S",
        "size": "3x3",
        "color": "Circle_Wooden",
        "product_image": "https://flashship.net/productImage/INTROn/W0011S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0011S",
        "size": "4x4",
        "color": "Circle_Wooden",
        "product_image": "https://flashship.net/productImage/INTROn/W0011S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0011SL",
        "size": "5x5",
        "color": "Circle_Wooden",
        "product_image": "https://flashship.net/productImage/INTROn/W0011SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53120,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0031S",
        "size": "5x5",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0031S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53121,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0031SM",
        "size": "7x7",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0031SM.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53122,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0031SL",
        "size": "9x9",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0031SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 54100,
        "product_type": "ORNAMENT",
        "brand": "GLASS",
        "style": "G0011S",
        "size": "3x3",
        "color": "Round_Glass",
        "product_image": "https://flashship.net/productImage/INTROn/G0011S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53114,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "3.5x3.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53115,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "4.5x4.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53116,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53117,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001S",
        "size": "3.5x3.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53118,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001S",
        "size": "4.5x4.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53119,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 55100,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SS",
        "size": "6x6",
        "color": "Personalized_Suncatcher",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S0011SS/Personalized_Suncatcher.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 55101,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SL",
        "size": "8x8",
        "color": "Personalized_Suncatcher",
        "product_image": "https://flashship.net/productImage/INTROn/S0011SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53123,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001S2L",
        "size": "4.5x4.5",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S2L.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51109,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "4x4",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53124,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "4x4",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 52111,
        "product_type": "ORNAMENT",
        "brand": "CERAMIC",
        "style": "C0011SS",
        "size": "3x3",
        "color": "Circle_Ceramic_2Side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/C0011SS/Circle_Ceramic_2Side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 52112,
        "product_type": "ORNAMENT",
        "brand": "CERAMIC",
        "style": "C0031SS",
        "size": "3x3",
        "color": "Heart_Ceramic_2Side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/C0031SS/Heart_Ceramic_2Side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51110,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "5x5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51111,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "6x6",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51112,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "7x7",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61100,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "3.5x3.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61101,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "4.5x4.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61102,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "5.5x5.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61109,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "4x4",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61110,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "5x5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61111,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "6x6",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61112,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "7x7",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61113,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "3.5x3.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61114,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "4x4",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61115,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001S",
        "size": "4.5x4.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61116,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "5.5x5.5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61117,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "5x5",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61118,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "6x6",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 61119,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SL",
        "size": "7x7",
        "color": "Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63111,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "3.5x3.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63112,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "4.5x4.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63113,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63114,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "3.5x3.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63115,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "4.5x4.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63116,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63120,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0031S",
        "size": "5x5",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0031S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63121,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0031SM",
        "size": "7x7",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0031SM.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63122,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0031SL",
        "size": "9x9",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0031SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63123,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001S2L",
        "size": "4.5x4.5",
        "color": "Wood_5mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S2L.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63124,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "4x4",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63125,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001S",
        "size": "3.5x3.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63126,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001S",
        "size": "4.5x4.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63127,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 71200,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "3x3",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 71201,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "4x4",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73114,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "3.5x3.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73115,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "4.5x4.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73116,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73117,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001S",
        "size": "3.5x3.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73118,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001S",
        "size": "4.5x4.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73119,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Acrylic_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WA0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73200,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101K",
        "size": "3x3",
        "color": "Wood_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/W0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73201,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101K",
        "size": "4x4",
        "color": "Wood_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/W0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 75100,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SS",
        "size": "6x6",
        "color": "Personalized_Suncatcher",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S0011SS/Personalized_Suncatcher.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 75101,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SL",
        "size": "8x8",
        "color": "Personalized_Suncatcher",
        "product_image": "https://flashship.net/productImage/INTROn/S0011SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51130,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SS",
        "size": "3.5x3.5",
        "color": "Acrylic_Custom_Shaped_2side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001SS/Acrylic_Custom_Shaped_2side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51131,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SS",
        "size": "4x4",
        "color": "Acrylic_Custom_Shaped_2side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001SS/Acrylic_Custom_Shaped_2side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51132,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SS",
        "size": "4.5x4.5",
        "color": "Acrylic_Custom_Shaped_2side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001SS/Acrylic_Custom_Shaped_2side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51133,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001LSS",
        "size": "5.5x5.5",
        "color": "Acrylic_Custom_Shaped_Large_2side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001LSS/Acrylic_Custom_Shaped_Large_2side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51134,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001LSS",
        "size": "5x5",
        "color": "Acrylic_Custom_Shaped_Large_2side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001LSS/Acrylic_Custom_Shaped_Large_2side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51135,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001LSS",
        "size": "6x6",
        "color": "Acrylic_Custom_Shaped_Large_2side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001LSS/Acrylic_Custom_Shaped_Large_2side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51136,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001LSS",
        "size": "7x7",
        "color": "Acrylic_Custom_Shaped_Large_2side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001LSS/Acrylic_Custom_Shaped_Large_2side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 51200,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "3x3",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51201,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "4x4",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53200,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101K",
        "size": "3x3",
        "color": "Wood_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/W0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53201,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101K",
        "size": "4x4",
        "color": "Wood_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/W0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63128,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "3.5x3.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63129,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "4.5x4.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63130,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63131,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001S",
        "size": "4x4",
        "color": "Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/W0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56105,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001CL",
        "size": "5.5x5.5",
        "color": "Acrylic_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001CL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56104,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001C",
        "size": "4.5x4.5",
        "color": "Acrylic_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001C.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56103,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001C",
        "size": "3.5x3.5",
        "color": "Acrylic_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001C.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VCL",
        "size": "7x7",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VCL",
        "size": "6x6",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56106,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VC",
        "size": "5x5",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56102,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001VCL",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56101,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001VC",
        "size": "4.5x4.5",
        "color": "Wood_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56100,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001VC",
        "size": "3.5x3.5",
        "color": "Wood_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51202,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101KS",
        "size": "2x2",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53202,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101KS",
        "size": "2x2",
        "color": "Wood_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/W0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 71202,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101KS",
        "size": "2x2",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 73202,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101KS",
        "size": "2x2",
        "color": "Wood_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/W0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 55102,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011XS",
        "size": "3.5x3.5",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/S0011XS.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 55103,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011XS",
        "size": "4x4",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/S0011XS.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 55104,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011S",
        "size": "5x5",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/S0011S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 65102,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011XS",
        "size": "3.5x3.5",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/S0011XS.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 65103,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011XS",
        "size": "4x4",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/S0011XS.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63119,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001SL",
        "size": "5.5x5.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63118,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "4.5x4.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 63117,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001S",
        "size": "3.5x3.5",
        "color": "Wood_Wood_Custom_Shaped",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001S.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 65101,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SL",
        "size": "8x8",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/INTROn/S0011SL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 65100,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SS",
        "size": "6x6",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S0011SS/Suncatcher_Wood_Acrylic.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 56110,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001C",
        "size": "3x4",
        "color": "Acrylic_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001C.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56109,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001C",
        "size": "3x4",
        "color": "Acrylic_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001C.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 77103,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SIG",
        "size": "6x6",
        "color": "Acrylic_Custom_Shape_Sign_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 77104,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SIGL",
        "size": "8x8",
        "color": "Acrylic_Custom_Shape_Sign_1layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001SIGL/Acrylic_Custom_Shape_Sign_1layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77105,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001SIGXL",
        "size": "10x10",
        "color": "Acrylic_Custom_Shape_Sign_1layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001SIGXL/Acrylic_Custom_Shape_Sign_1layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77100,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SIG",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Sign_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 77101,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SIGL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Sign_1layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIGL/Wood_Custom_Shape_Sign_1layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77102,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SIGXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Sign_1layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIGXL/Wood_Custom_Shape_Sign_1layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77106,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SIGS",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Sign_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001SIGS.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 77107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SIGSL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Sign_2layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIGSL/Wood_Custom_Shape_Sign_2layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001SIGSXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Sign_2layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIGSXL/Wood_Custom_Shape_Sign_2layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78105,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001STXL",
        "size": "10x10",
        "color": "Acrylic_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001STXL/Acrylic_Custom_Shape_Standing.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78104,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001STL",
        "size": "8x8",
        "color": "Acrylic_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001STL/Acrylic_Custom_Shape_Standing.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78103,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001ST",
        "size": "6x6",
        "color": "Acrylic_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001ST/Acrylic_Custom_Shape_Standing.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78102,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001STXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STXL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 78101,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001STL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 78100,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001ST",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/INTROn/W0001ST.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 58105,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001STXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001STXL/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 58104,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001STL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001STL/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 58103,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001ST",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001ST/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 66106,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VC",
        "size": "5x5",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 66107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VCL",
        "size": "6x6",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 66108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VCL",
        "size": "7x7",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76100,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001VC",
        "size": "3.5x3.5",
        "color": "Wood_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76101,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001VC",
        "size": "4.5x4.5",
        "color": "Wood_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76102,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001VCL",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/W0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76103,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001C",
        "size": "3.5x3.5",
        "color": "Acrylic_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001C.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76104,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001C",
        "size": "4.5x4.5",
        "color": "Acrylic_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001C.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76105,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001CL",
        "size": "5.5x5.5",
        "color": "Acrylic_Custom_Shaped_CarClip_1layer",
        "product_image": "https://flashship.net/productImage/INTROn/A0001CL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76106,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VC",
        "size": "5x5",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VCL",
        "size": "6x6",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 76108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VCL",
        "size": "7x7",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VCL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 56111,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VC",
        "size": "4x4",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 78111,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIGXL",
        "size": "10x10",
        "color": "Acrylic_Custom_Shape_Standing_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 78110,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIGL",
        "size": "8x8",
        "color": "Acrylic_Custom_Shape_Standing_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 78109,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIG",
        "size": "6x6",
        "color": "Acrylic_Custom_Shape_Standing_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 78108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIGXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIGXL/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIGL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIGL/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78106,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIG",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIG/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 58106,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001ST",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001ST/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 66111,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001VC",
        "size": "4x4",
        "color": "Wood_Custom_Shaped_CarClip_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/WW0001VC.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 55105,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001S",
        "size": "6x6",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001S/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 55106,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001M",
        "size": "8x8",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001M/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 55107,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001L",
        "size": "10x10",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001L/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 55108,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001XL",
        "size": "12x12",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001XL/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77201,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WC0001SIG",
        "size": "12x12",
        "color": "Wooden_Custom_Sign_1_layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WC0001SIG/Wooden_Custom_Sign_1_layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77202,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WC0001SIGL",
        "size": "14x14",
        "color": "Wooden_Custom_Sign_1_layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WC0001SIGL/Wooden_Custom_Sign_1_layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77203,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WC0001SIGXL",
        "size": "18x18",
        "color": "Wooden_Custom_Sign_1_layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WC0001SIGXL/Wooden_Custom_Sign_1_layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78118,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001M",
        "size": "3x3",
        "color": "Wood_Wood_Custom_Shape_Magnets_2_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001M/Wood_Wood_Custom_Shape_Magnets_2_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78120,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001M",
        "size": "4x4",
        "color": "Wood_Wood_Custom_Shape_Magnets_2_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001M/Wood_Wood_Custom_Shape_Magnets_2_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 78122,
        "product_type": "ORNAMENT",
        "brand": "WOOD_WOOD",
        "style": "WW0001LM",
        "size": "5x5",
        "color": "Wood_Wood_Custom_Shape_Magnets_2_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001LM/Wood_Wood_Custom_Shape_Magnets_2_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77112,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001M",
        "size": "3x3",
        "color": "Wood_Acrylic_Custom_Shape_Magnets_2_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WA0001M/Wood_Acrylic_Custom_Shape_Magnets_2_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77114,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001M",
        "size": "4x4",
        "color": "Wood_Acrylic_Custom_Shape_Magnets_2_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WA0001M/Wood_Acrylic_Custom_Shape_Magnets_2_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77116,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "WA0001LM",
        "size": "5x5",
        "color": "Wood_Acrylic_Custom_Shape_Magnets_2_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WA0001LM/Wood_Acrylic_Custom_Shape_Magnets_2_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77123,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001M",
        "size": "3x3",
        "color": "Wooden_Custom_Shape_Magnets_1_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001M/Wooden_Custom_Shape_Magnets_1_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77124,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001M",
        "size": "4x4",
        "color": "Wooden_Custom_Shape_Magnets_1_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001M/Wooden_Custom_Shape_Magnets_1_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77110,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0001LM",
        "size": "5x5",
        "color": "Wooden_Custom_Shape_Magnets_1_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001LM/Wooden_Custom_Shape_Magnets_1_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77120,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001M",
        "size": "3x3",
        "color": "Acrylic_Custom_Shape_Magnets_1_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001M/Acrylic_Custom_Shape_Magnets_1_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77121,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001M",
        "size": "4x4",
        "color": "Acrylic_Custom_Shape_Magnets_1_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001M/Acrylic_Custom_Shape_Magnets_1_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77122,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0001LM",
        "size": "5x5",
        "color": "Acrylic_Custom_Shape_Magnets_1_layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0001LM/Acrylic_Custom_Shape_Magnets_1_layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 72203,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101SSK",
        "size": "2x2",
        "color": "Acrylic_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0101SSK/Acrylic_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77204,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101SSK",
        "size": "3x3",
        "color": "Acrylic_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0101SSK/Acrylic_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77205,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101SSK",
        "size": "4x4",
        "color": "Acrylic_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0101SSK/Acrylic_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73203,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101SSK",
        "size": "2x2",
        "color": "Wood_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0101SSK/Wood_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73204,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101SSK",
        "size": "3x3",
        "color": "Wood_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0101SSK/Wood_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 73205,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0101SSK",
        "size": "4x4",
        "color": "Wood_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0101SSK/Wood_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 71203,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WC0001S",
        "size": "3.5x3.5",
        "color": "Wooden_Ornament_Car",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WC0001S/Wooden_Ornament_Car.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 71204,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WC0001S",
        "size": "4.5x4.5",
        "color": "Wooden_Ornament_Car",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WC0001S/Wooden_Ornament_Car.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 71205,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AC0001S",
        "size": "3.5x3.5",
        "color": "Acrylic_Ornament_Car",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/AC0001S/Acrylic_Ornament_Car.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 71206,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AC0001S",
        "size": "4.5x4.5",
        "color": "Acrylic_Ornament_Car",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/AC0001S/Acrylic_Ornament_Car.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 71207,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AC0001SS",
        "size": "3.5x3.5",
        "color": "Acrylic_Ornament_Car_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/AC0001SS/Acrylic_Ornament_Car_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 71208,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AC0001SS",
        "size": "4.5x4.5",
        "color": "Acrylic_Ornament_Car_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/AC0001SS/Acrylic_Ornament_Car_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67102,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIG",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIG/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67103,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001ST",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001ST/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67104,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001STL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001STL/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67105,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001STXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001STXL/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67106,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001ST",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001ST/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIGL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIGL/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIGXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIGXL/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67109,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIG",
        "size": "6x6",
        "color": "Acrylic_Custom_Shape_Standing_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 67110,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIGL",
        "size": "8x8",
        "color": "Acrylic_Custom_Shape_Standing_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 67111,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIGXL",
        "size": "10x10",
        "color": "Acrylic_Custom_Shape_Standing_2layer",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 68103,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001ST",
        "size": "5.5x5.5",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001ST/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 68104,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001STL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001STL/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 68105,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001STXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001STXL/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 68106,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002ST",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001ST.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 68107,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002STL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 68108,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002STXL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STXL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 68109,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIG",
        "size": "6x6",
        "color": "Acrylic_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 68110,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIGL",
        "size": "8x8",
        "color": "Acrylic_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 68111,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "AA0001SIGXL",
        "size": "10x10",
        "color": "Acrylic_Custom_Shape_Standing",
        "product_image": "https://flashship.net/productImage/INTROn/AA0001SIG.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 68112,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "WW0001ST",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001ST/Wood_Custom_Shape_Standing_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 65109,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SXL",
        "size": "10x10",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S0011SXL/Suncatcher_Wood_Acrylic.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 55109,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SXL",
        "size": "10x10",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S0011SXL/Suncatcher_Wood_Acrylic.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 65110,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SXXL",
        "size": "12x12",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S0011SXXL/Suncatcher_Wood_Acrylic.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 55110,
        "product_type": "ORNAMENT",
        "brand": "WOOD_ACRYLIC",
        "style": "S0011SXXL",
        "size": "12x12",
        "color": "Suncatcher_Wood_Acrylic",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S0011SXXL/Suncatcher_Wood_Acrylic.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 79130,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "4x4",
        "color": "Wood_Personalized_Bookmark_Sky Blue",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79129,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "4x4",
        "color": "Wood_Personalized_Bookmark_Deep Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79128,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "4x4",
        "color": "Wood_Personalized_Bookmark_Dark Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79127,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "4x4",
        "color": "Wood_Personalized_Bookmark_Pink",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79126,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "4x4",
        "color": "Wood_Personalized_Bookmark_Gray",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79125,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "3x3",
        "color": "Wood_Personalized_Bookmark_Sky Blue",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79124,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "3x3",
        "color": "Wood_Personalized_Bookmark_Deep Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79123,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "3x3",
        "color": "Wood_Personalized_Bookmark_Dark Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79122,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "3x3",
        "color": "Wood_Personalized_Bookmark_Pink",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79121,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201BL",
        "size": "3x3",
        "color": "Wood_Personalized_Bookmark_Gray",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79115,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "4x4",
        "color": "Acrylic_Personalized_Bookmark_Deep Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79114,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "4x4",
        "color": "Acrylic_Personalized_Bookmark_Sky Blue",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79113,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "4x4",
        "color": "Acrylic_Personalized_Bookmark_Dark Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79112,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "4x4",
        "color": "Acrylic_Personalized_Bookmark_Pink",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79111,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "4x4",
        "color": "Acrylic_Personalized_Bookmark_Gray",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79109,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "3x3",
        "color": "Acrylic_Personalized_Bookmark_Deep Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79108,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "3x3",
        "color": "Acrylic_Personalized_Bookmark_Sky Blue",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79107,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "3x3",
        "color": "Acrylic_Personalized_Bookmark_Dark Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79106,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "3x3",
        "color": "Acrylic_Personalized_Bookmark_Pink",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79105,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201BL",
        "size": "3x3",
        "color": "Acrylic_Personalized_Bookmark_Gray",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79119,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201B",
        "size": "2x8",
        "color": "Wood_Personalized_Bookmark_Sky Blue",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79120,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201B",
        "size": "2x8",
        "color": "Wood_Personalized_Bookmark_Deep Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79118,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201B",
        "size": "2x8",
        "color": "Wood_Personalized_Bookmark_Dark Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79117,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201B",
        "size": "2x8",
        "color": "Wood_Personalized_Bookmark_Pink",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79116,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0201B",
        "size": "2x8",
        "color": "Wood_Personalized_Bookmark_Gray",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/W0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79104,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201B",
        "size": "2x8",
        "color": "Acrylic_Personalized_Bookmark_Deep Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79103,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201B",
        "size": "2x8",
        "color": "Acrylic_Personalized_Bookmark_Sky Blue",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79102,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201B",
        "size": "2x8",
        "color": "Acrylic_Personalized_Bookmark_Dark Green",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79101,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201B",
        "size": "2x8",
        "color": "Acrylic_Personalized_Bookmark_Pink",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 79100,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0201B",
        "size": "2x8",
        "color": "Acrylic_Personalized_Bookmark_Gray",
        "color_hex": "",
        "product_image": "https://flashship.net/productImage/INTROn/A0201B.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51203,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "3.5x4.5",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 51204,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "4x5",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 71210,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "3.5x4.5",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 71211,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101K",
        "size": "4x5",
        "color": "Acrylic_Keychain",
        "product_image": "https://flashship.net/productImage/INTROn/A0101K.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 65111,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001S",
        "size": "6x6",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001S/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 65112,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001M",
        "size": "8x8",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001M/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 65113,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001L",
        "size": "10x10",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001L/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 65114,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "S001XL",
        "size": "12x12",
        "color": "Suncatcher_1_Layer",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/S001XL/Suncatcher_1_Layer.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67112,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIGXS",
        "size": "4x4",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIGXS/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67113,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIGS",
        "size": "5x5",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIGS/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77109,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001SIG5MM",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Sign_1layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIG5MM/Wood_Custom_Shape_Sign_1layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77113,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001SIGL5MM",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Sign_1layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIGL5MM/Wood_Custom_Shape_Sign_1layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77115,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001SIGXL5MM",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Sign_1layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIGXL5MM/Wood_Custom_Shape_Sign_1layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77117,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001SIG5S",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Sign_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIG5S/Wood_Custom_Shape_Sign_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77118,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001SIG5L",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Sign_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIG5L/Wood_Custom_Shape_Sign_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 77119,
        "product_type": "ORNAMENT",
        "brand": "WOOD_5MM",
        "style": "W0001SIG5XL",
        "size": "10x10",
        "color": "Wood_Custom_Shape_Sign_2layer_5mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/W0001SIG5XL/Wood_Custom_Shape_Sign_2layer_5mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 67114,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "WW0001SIGXXL",
        "size": "12x12",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/WW0001SIGXXL/Wood_Custom_Shape_Standing_2layer_3mm.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48730,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDCOCOABLEND_BC",
        "color_hex": "#65443C",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDCOCOABLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48740,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDFORESTBLEND_BC",
        "color_hex": "#183028",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDFORESTBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48750,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDMAROONBLEND_BC",
        "color_hex": "#672e45",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDMAROONBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48760,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XS",
        "color": "SOLIDVINTAGENAVYBLEND_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDVINTAGENAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48731,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDCOCOABLEND_BC",
        "color_hex": "#65443C",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDCOCOABLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48741,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDFORESTBLEND_BC",
        "color_hex": "#183028",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDFORESTBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48751,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDMAROONBLEND_BC",
        "color_hex": "#672e45",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDMAROONBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48761,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "S",
        "color": "SOLIDVINTAGENAVYBLEND_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDVINTAGENAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48732,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDCOCOABLEND_BC",
        "color_hex": "#65443C",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDCOCOABLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48742,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDFORESTBLEND_BC",
        "color_hex": "#183028",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDFORESTBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48752,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDMAROONBLEND_BC",
        "color_hex": "#672e45",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDMAROONBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48762,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "M",
        "color": "SOLIDVINTAGENAVYBLEND_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDVINTAGENAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48733,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDCOCOABLEND_BC",
        "color_hex": "#65443C",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDCOCOABLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48743,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDFORESTBLEND_BC",
        "color_hex": "#183028",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDFORESTBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48753,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDMAROONBLEND_BC",
        "color_hex": "#672e45",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDMAROONBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48763,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "L",
        "color": "SOLIDVINTAGENAVYBLEND_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDVINTAGENAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48734,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDCOCOABLEND_BC",
        "color_hex": "#65443C",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDCOCOABLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48744,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDFORESTBLEND_BC",
        "color_hex": "#183028",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDFORESTBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48754,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDMAROONBLEND_BC",
        "color_hex": "#672e45",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDMAROONBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48764,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "XL",
        "color": "SOLIDVINTAGENAVYBLEND_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDVINTAGENAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48735,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDCOCOABLEND_BC",
        "color_hex": "#65443C",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDCOCOABLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48745,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDFORESTBLEND_BC",
        "color_hex": "#183028",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDFORESTBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48755,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDMAROONBLEND_BC",
        "color_hex": "#672e45",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDMAROONBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48765,
        "product_type": "BABYTEE",
        "brand": "BELLA",
        "style": "B1010",
        "size": "2XL",
        "color": "SOLIDVINTAGENAVYBLEND_BC",
        "color_hex": "#48555D",
        "product_image": "https://flashship.net/productImage/DetailProduct/BABYTEE/B1010/SOLIDVINTAGENAVYBLEND_BC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 53125,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002ST",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001ST.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53126,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002STL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 53127,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002STXXL",
        "size": "12x12",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 65119,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101SSK",
        "size": "2x2",
        "color": "Acrylic_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0101SSK/Acrylic_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 65120,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101SSK",
        "size": "3x3",
        "color": "Acrylic_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0101SSK/Acrylic_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 65121,
        "product_type": "ORNAMENT",
        "brand": "ACRYLIC",
        "style": "A0101SSK",
        "size": "4x4",
        "color": "Acrylic_Keychain_2_side",
        "product_image": "https://flashship.net/productImage/DetailProduct/ORNAMENT/A0101SSK/Acrylic_Keychain_2_side.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 50004,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002ST",
        "size": "6x6",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001ST.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 50005,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002STL",
        "size": "8x8",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 50006,
        "product_type": "ORNAMENT",
        "brand": "WOOD",
        "style": "W0002STXXL",
        "size": "12x12",
        "color": "Wood_Custom_Shape_Standing_2layer_3mm",
        "product_image": "https://flashship.net/productImage/INTROn/W0001STL.png",
        "stock": "In Stock"
    },
    {
        "variant_id": 48781,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUEJEAN_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48782,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48783,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48784,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48785,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "BLUEJEAN_CC",
        "color_hex": "#647692",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUEJEAN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48771,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48772,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48773,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48774,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48775,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "BLACK_CC",
        "color_hex": "#25282A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLACK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48801,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48802,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48803,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48804,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48805,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "BRICK_CC",
        "color_hex": "#8A1538",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRICK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48811,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "BRIGHTSALMON_CC",
        "color_hex": "#FF6D6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRIGHTSALMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48812,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "BRIGHTSALMON_CC",
        "color_hex": "#FF6D6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRIGHTSALMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48813,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "BRIGHTSALMON_CC",
        "color_hex": "#FF6D6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRIGHTSALMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48814,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "BRIGHTSALMON_CC",
        "color_hex": "#FF6D6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRIGHTSALMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48815,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "BRIGHTSALMON_CC",
        "color_hex": "#FF6D6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BRIGHTSALMON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48791,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48792,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48793,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48794,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48795,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "BLUESPRUCE_CC",
        "color_hex": "#3E5D58",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/BLUESPRUCE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48831,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48832,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48833,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48834,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48835,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "CHAMBRAY_CC",
        "color_hex": "#BDD6E6",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHAMBRAY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48821,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHALKYMINT_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48822,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHALKYMINT_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48823,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48824,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48825,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "CHALKYMINT_CC",
        "color_hex": "#5CB8B2",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CHALKYMINT_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48841,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48842,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48843,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRIMSON_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48844,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRIMSON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48845,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "CRIMSON_CC",
        "color_hex": "#A4123F",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRIMSON_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48851,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48852,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48853,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48854,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRUNCHBERRY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48855,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "CRUNCHBERRY_CC",
        "color_hex": "#EF4A81",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/CRUNCHBERRY_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48861,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48862,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48863,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/DENIM_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48864,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48865,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "DENIM_CC",
        "color_hex": "#425563",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/DENIM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48871,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48872,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48873,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/FLOBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48874,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/FLOBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48875,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "FLOBLUE_CC",
        "color_hex": "#5576D1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/FLOBLUE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48881,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GRAPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48882,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GRAPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48883,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GRAPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48884,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GRAPE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48885,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "GRAPE_CC",
        "color_hex": "#211551",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GRAPE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48891,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48892,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48893,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48894,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48895,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "GREY_CC",
        "color_hex": "#716E6A",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/GREY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48901,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "ICEBLUE_CC",
        "color_hex": "#5B7F95",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ICEBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48902,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "ICEBLUE_CC",
        "color_hex": "#5B7F95",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ICEBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48903,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "ICEBLUE_CC",
        "color_hex": "#5B7F95",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ICEBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48904,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "ICEBLUE_CC",
        "color_hex": "#5B7F95",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ICEBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48905,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "ICEBLUE_CC",
        "color_hex": "#5B7F95",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ICEBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48911,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48912,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48913,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48914,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48915,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "IVORY_CC",
        "color_hex": "#E7CEB5",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/IVORY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48921,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48922,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48923,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48924,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48925,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "LAGOONBLUE_CC",
        "color_hex": "#05C3DE",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LAGOONBLUE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48931,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48932,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48933,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48934,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48935,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "LIGHTGREEN_CC",
        "color_hex": "#5C7F71",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/LIGHTGREEN_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48941,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "MELON_CC",
        "color_hex": "#FA9370",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/MELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48942,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "MELON_CC",
        "color_hex": "#FA9370",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/MELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48943,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "MELON_CC",
        "color_hex": "#FA9370",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/MELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48944,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "MELON_CC",
        "color_hex": "#FA9370",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/MELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48945,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "MELON_CC",
        "color_hex": "#FA9370",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/MELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49021,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49022,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49023,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49024,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49025,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "TRUENAVY_CC",
        "color_hex": "#041E42",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/TRUENAVY_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48951,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48952,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48953,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48954,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48955,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "NEONPINK_CC",
        "color_hex": "#F04E98",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONPINK_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48961,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48962,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48963,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48964,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48965,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "NEONREDORANGE_CC",
        "color_hex": "#FF585D",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/NEONREDORANGE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48971,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48972,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/PEPPER_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48973,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/PEPPER_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48974,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/PEPPER_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48975,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "PEPPER_CC",
        "color_hex": "#4E4B48",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/PEPPER_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 48981,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "ROYALCARIBE_CC",
        "color_hex": "#0082BA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ROYALCARIBE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48982,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "ROYALCARIBE_CC",
        "color_hex": "#0082BA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ROYALCARIBE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48983,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "ROYALCARIBE_CC",
        "color_hex": "#0082BA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ROYALCARIBE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48984,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "ROYALCARIBE_CC",
        "color_hex": "#0082BA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ROYALCARIBE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48985,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "ROYALCARIBE_CC",
        "color_hex": "#0082BA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/ROYALCARIBE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48991,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48992,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48993,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48994,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SANDSTONE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 48995,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "SANDSTONE_CC",
        "color_hex": "#A69F88",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SANDSTONE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49001,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49002,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49003,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49004,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SAPPHIRE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49005,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "SAPPHIRE_CC",
        "color_hex": "#007DBA",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SAPPHIRE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49011,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49012,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SEAFOAM_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49013,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SEAFOAM_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49014,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SEAFOAM_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49015,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "SEAFOAM_CC",
        "color_hex": "#487A7B",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/SEAFOAM_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49031,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/VIOLET_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49032,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/VIOLET_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49033,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/VIOLET_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49034,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/VIOLET_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49035,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "VIOLET_CC",
        "color_hex": "#7474C1",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/VIOLET_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49041,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49042,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49043,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49044,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49045,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "WATERMELON_CC",
        "color_hex": "#F4364C",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WATERMELON_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49051,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "S",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WHITE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49052,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "M",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WHITE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49053,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "L",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WHITE_CC.jpeg",
        "stock": "Out Of Stock"
    },
    {
        "variant_id": 49054,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "XL",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WHITE_CC.jpeg",
        "stock": "In Stock"
    },
    {
        "variant_id": 49055,
        "product_type": "TANKTOP",
        "brand": "COMFORT",
        "style": "C9360",
        "size": "2XL",
        "color": "WHITE_CC",
        "color_hex": "#FFFFFF",
        "product_image": "https://flashship.net/productImage/DetailProduct/TANKTOP/C9360/WHITE_CC.jpeg",
        "stock": "Out Of Stock"
    }
]
export default flashship
